"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = profileRequest;

var _axios = _interopRequireDefault(require("axios"));

var _reactCookies = _interopRequireDefault(require("react-cookies"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ENDPOINT = process.env.PROFILE_API_ENDPOINT || 'https://api-profile.domru.ru/v1';

function profileRequest(citydomain, accessToken, billingHost) {
  var token = accessToken || _reactCookies["default"].load('ACCESS_TOKEN');

  var domain = citydomain || _reactCookies["default"].load('citydomain');

  var headers = {
    'Domain': domain,
    'Authorization': "Bearer ".concat(token),
    'Content-Type': 'application/json'
  };

  if (billingHost) {
    headers['Billing-Host'] = billingHost;
  }

  return _axios["default"].create({
    baseURL: ENDPOINT,
    headers: headers
  });
}

var x = {
  "connectedInTariff": [{
    "id": 92,
    "active": 2190493,
    "alias": "ctv-pockets-premialnyy",
    "available": 0,
    "baseCost": 0,
    "channels": [{
      "chid": 3841,
      "title": "8 канал",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886439.png",
      "description": "Восьмой канал – информационно-развлекательный телеканал. В эфире: художественные фильмы, аналитические материалы, интервью со знаменитыми музыкантами и киноактерами, погода на каждый день, юмористические и кулинарные телепроекты, информационные выпуски, утренние и развлекательные шоу.",
      "url": "http://www.8tv.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "8-kanal",
      "xvid": 31,
      "button": "№ кнопки 32",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 158,
      "title": "Домашний",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871690.png",
      "description": "Смотрите душевные сериалы — «Катино счастье», «Память сердца» и другие. Готовьте лакомства для близких с «Домашней кухней», научитесь слышать и понимать друг друга с психологами из «Понять и простить».",
      "url": "https://www.domashniy.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "domashniy",
      "xvid": 71,
      "button": "№ кнопки 14",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 79,
      "title": "Звезда",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871183.png",
      "description": "В эфире телеканала новости военной индустрии, исторические программы «Тайны века» и «Улика из прошлого», передачи об оружии, документальные и художественные фильмы о войне, полководцах, легендарных событиях.",
      "url": "http://tvzvezda.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "zvezda",
      "xvid": 491,
      "button": "№ кнопки 17",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 1252,
      "title": "Карусель",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474873991.png",
      "description": "Детский телеканал с мультфильмами и познавательными передачами. В эфире — Свинка Пеппа и другие веселые персонажи. Просыпайтесь с Филей и Каркушей, делайте зарядку с цыпленком Лимончиком, учитесь заботиться о здоровье с доктором Малышкиной.",
      "url": "https://www.karusel-tv.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "karusel",
      "xvid": 145,
      "button": "№ кнопки 8",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 5131,
      "title": "МАТЧ!",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1572609719.png",
      "description": "Весь спорт — от футбола до шахмат. Смотрите Лигу наций УЕФА, ралли «Шелковый путь», прыжки в воду, теннис и шахматные турниры. Знакомьтесь с выдающимися спортсменами, загляните в закулисье большого спорта.",
      "url": "http://matchtv.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "match",
      "xvid": 1301,
      "button": "№ кнопки 3",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 4631,
      "title": "МИР",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474891600.png",
      "description": "Учитесь строить отношения с ток-шоу «Такому мама не научит», сражайтесь за правду в «Зале суда». Также в эфире детективные сериалы, кулинарное шоу «Как в ресторане», познавательные программы и классика советского кино.",
      "url": "http://www.mirtv.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "mir",
      "xvid": 2081,
      "button": "№ кнопки 18",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 10003,
      "title": "Москва 24",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1593516969.png",
      "description": "Городской круглосуточный информационный канал. Городские новости в прямом эфире каждый час. Основная задача канала – максимально подробно и оперативно информировать обо всех событиях, происходящих в столице.",
      "url": "https://www.m24.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "moskva-24",
      "xvid": 4053,
      "button": "№ кнопки 23",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 10013,
      "title": "Москва Доверие",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1593508756.png",
      "description": "Cоциально ориентированный телеканал. Программы посвящены людям, их духовной, нравственной, культурной и общественной деятельности.",
      "url": "https://www.doverie-tv.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "moskva-doverie",
      "xvid": 1731,
      "button": "№ кнопки 48",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 167,
      "title": "МУЗ ТВ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1635832585.png",
      "description": "Телеканал для меломанов. Будьте в курсе событий шоу-бизнеса, пойте в караоке, смотрите новые клипы и слушайте хиты любимых исполнителей. Побывайте на концерте кумира, не выходя из дома.",
      "url": "http://muz-tv.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "muz-tv",
      "xvid": 197,
      "button": "№ кнопки 20",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 155,
      "title": "НТВ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871628.png",
      "description": "Смотрите «Ментовские войны» и другие детективные сериалы. Путешествуйте с программой «Их нравы», делайте ремонт с «Квартирным вопросом», узнавайте тайны звезд в «Секрете на миллион» с Лерой Кудрявцевой.",
      "url": "http://www.ntv.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "ntv",
      "xvid": 213,
      "button": "№ кнопки 4",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 3351,
      "title": "ОТР",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474885579.png",
      "description": "Телеканал для тех, кому не все равно, что происходит в стране. Смотрите прямые эфиры с обсуждением острых социальных вопросов и политики, новости столицы и регионов, отечественные фильмы и сериалы.",
      "url": "https://otr-online.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "otr",
      "xvid": 251,
      "button": "№ кнопки 9",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 148,
      "title": "Первый канал",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871561.png",
      "description": "В эфире главные новости России и мира, а также ток-шоу с ведущими журналистами страны. Узнайте секреты здоровья у Елены Малышевой, следите за последними трендами моды в «Модном приговоре». Смотрите сериалы, премьеры фильмов и классику кино.",
      "url": "http://www.1tv.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "pervyy-kanal",
      "xvid": 1,
      "button": "№ кнопки 1",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 3491,
      "title": "Пятница",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886000.png",
      "description": "Телеканал для любознательных и активных. Открывайте мир с ведущими легендарного шоу «Орел и решка», учитесь печь торты с «Кондитером», изучайте права потребителя с «Инсайдерами».",
      "url": "https://friday.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "pyatnitsa",
      "xvid": 114,
      "button": "№ кнопки 16",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 159,
      "title": "Пятый канал",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871696.png",
      "description": "«Информационно-развлекательный канал с новостями, светскими хрониками и сериалами. Смотрите «След» и все сезоны «Глухаря», узнавайте о пользе и вреде продуктов в передаче «Вся правда о…».",
      "url": "http://www.5-tv.ru",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "pyatyy-kanal",
      "xvid": 260,
      "button": "№ кнопки 5",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 151,
      "title": "РЕН ТВ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1527585005.jpg",
      "description": "Узнавайте шокирующие гипотезы и сенсационные факты в программах «Территория заблуждений», «Тайны Чапман» и «Загадки человечества». Также в эфире новости, «Анекдот-шоу» с Вадимом Галыгиным и популярные сериалы.",
      "url": "http://ren.tv/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "ren-tv",
      "xvid": 276,
      "button": "№ кнопки 11",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 156,
      "title": "Россия 24",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871642.png",
      "description": "В эфире новости со всего мира, прямые трансляции с места событий. Смотрите криминальные хроники и прогноз погоды, узнавайте новое о спорте и курсе валют, участвуйте в горячих дебатах с Владимиром Соловьевым в программе «Воскресный вечер».",
      "url": "http://www.vesti.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "rossiya-24",
      "xvid": 463,
      "button": "№ кнопки 7",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 164,
      "title": "Россия Культура",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871710.png",
      "description": "В эфире обзор событий российской и мировой культуры, программы о науке и искусстве. Смотрите театральные постановки, изучайте английский с «Полиглотом», знакомьтесь с шедеврами мирового и отечественного кино.",
      "url": "http://tvkultura.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "rossiya-kultura",
      "xvid": 159,
      "button": "№ кнопки 6",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 149,
      "title": "Россия-1",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871590.png",
      "description": "Смотрите новости страны и регионов в программе «Вести», будьте в курсе самых скандальных историй в «Прямом эфире» с Андреем Малаховым, узнавайте все о жизни звезд в ток-шоу «Судьба человека». А программа «О самом главном» расскажет, как сохранить здоровье.",
      "url": "https://russia.tv/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "rossiya-1",
      "xvid": 297,
      "button": "№ кнопки 2",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 5041,
      "title": "Спас",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474891881.png",
      "description": "В эфире канала беседы со служителями церкви, программы о православных ценностях. Путешествуйте по святыням России, узнавайте секреты монастырской кухни. Смотрите добрые мультфильмы и душевное кино всей семьей.",
      "url": "http://spastv.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "spas",
      "xvid": 1211,
      "button": "№ кнопки 12",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 173,
      "title": "СТС",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1515673901.png",
      "description": "В программе телеканала юмор и развлечения. Смотрите «Молодежку», «Ворониных» и другие любимые сериалы. Не пропустите мировые кинохиты — фантастику, триллеры и комедии. А «Ералаш» и «Уральские пельмени» всегда поднимут настроение.",
      "url": "https://ctc.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "sts",
      "xvid": 364,
      "button": "№ кнопки 13",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 4271,
      "title": "ТВ-3",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1479972078.png",
      "description": "Телеканал для любителей мистики и сверхъестественного. Таинственные истории и гадания, предсказания слепой провидицы, реальные призраки в шоу «Охотники за привидениями». Узнайте, как победить зомби и вампиров.",
      "url": "http://tv3.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "tv-3",
      "xvid": 448,
      "button": "№ кнопки 15",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 165,
      "title": "ТВЦ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1475055490.png",
      "description": "Новости политики и экономики, спорта и культуры. Смотрите криминальные сводки, полезные советы для покупателей в программе «Естественный отбор», истории звезд, юмористические шоу, кино и сериалы.",
      "url": "http://www.tvc.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "tvts",
      "xvid": 451,
      "button": "№ кнопки 10",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 6803,
      "title": "Телеканал 360",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1527746798.jpeg",
      "description": "Информационно-развлекательный телеканал. Слоган канала: «Перемены сейчас — Перемены к лучшему!»",
      "url": "https://360tv.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "telekanal-360",
      "xvid": 1721,
      "button": "№ кнопки 22",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 9663,
      "title": "Телеканал 360 Новости",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1575023888.png",
      "description": "Информационный телеканал, на котором зрители 24 часа в сутки могут следить за самыми значимыми событиями московского региона, страны и мира. Каждый час — выпуски новостей в прямом эфире, а также метеосводки, актуальная информация о загруженности дорог столичного региона в утренний и вечерний час-пик, информация о полезных сервисах Правительства Московской области. У канала широкая филиальная сеть по Подмосковью — 7 филиалов (Балашиха, Химки, Дубна, Истра, Одинцово, Солнечногорск, Ногинск). Для съемок новостей используется собственный «воздушный флот» — вертолет, аэростат, мультикоптеры - и самая большая в стране телестудия с естественным освещением, расположенная в Доме Правительства Московской области.",
      "url": "https://360tv.ru",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "telekanal-360-novosti",
      "xvid": 4133,
      "button": "№ кнопки 32",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 171,
      "title": "ТНТ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1475055337.png",
      "description": "Развлекательный телеканал с юмористическими шоу и сериалами. Будет смешно: включайте «Интерны», «Универ» или Comedy Club. Следите за развитием отношений участников скандального «Дома-2».",
      "url": "http://www.tnt-tv.ru/",
      "hd": 0,
      "thid": 1,
      "display": 3,
      "alias": "tnt",
      "xvid": 398,
      "button": "№ кнопки 19",
      "bids": 92,
      "theme": {
        "thid": 1,
        "name": "Общедоступные",
        "plural": "Общедоступные",
        "alias": "polit",
        "weight": 0
      }
    }, {
      "chid": 6543,
      "title": ".black",
      "biglogo": "/chbiglogo/1624422451.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1624422346.png",
      "description": "Телеканал для тех, кто не любит компромиссов. Захватывающий, правдивый и разнообразный контент с ядром от Sony Pictures, ориентирован в основном на мужчин. Он открывает мир, полный̆ возможностей̆, сильных характеров и вызовов.",
      "url": "https://www.sonyturbo.ru/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "black",
      "xvid": 1871,
      "button": "№ кнопки 217",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 2783,
      "title": ".red",
      "biglogo": "/chbiglogo/1624422876.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1624423069.png",
      "description": "Телеканал для современной женской аудитории. Динамичный, яркий, провокационный. В основе контентного наполнения лучшие и любимые сериалы и программы производства Sony Pictures Television, Paramount, BBC, Universal, Disney, Freemantle, MGM и другие.",
      "url": "http://www.sonychannel.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "red",
      "xvid": 345,
      "button": "№ кнопки 209",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 226,
      "title": ".sci-fi",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1624423439.png",
      "description": "Свежий инновационный развлекательный телеканал, увлекающий в мир неизведанного и необъяснимого. Истории про будущее, невероятные технологии, космос, параллельные миры, супергероев, мистику, необъяснимые явления, мифы и легенды.",
      "url": "http://www.sonyscifi.ru",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "sci-fi",
      "xvid": 47,
      "button": "№ кнопки 210",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 3411,
      "title": "A1",
      "biglogo": "/chbiglogo/1587555204.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1478599976.png",
      "description": "Телеканал для мужчин. Рейтинговые мужские сериалы: «Рэй Донован», «Черные паруса», «Банши», «Миллиарды», «Настоящий детектив».\r\nПодборка фильмов популярных жанров — от экшн-блокбастеров до черных комедий.  Документальные программы — независимые журналистские расследования, биографии и интервью.",
      "url": "http://amedia.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "a1",
      "xvid": 38,
      "button": "№ кнопки 220",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 3691,
      "title": "A2",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1478599898.png",
      "description": "Телеканал с фильмами и сериалами про любовь. Смотрите мелодрамы и романтические комедии — «Мой первый роман», «Любовники», «Развод». Оцените наряды звезд в репортажах с красных дорожек кинофестивалей.",
      "url": "http://amedia2.ru/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "a2",
      "xvid": 37,
      "button": "№ кнопки 219",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 7953,
      "title": "Amedia HIT HD",
      "biglogo": "/chbiglogo/1587705951.jpg",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561449337.jpg",
      "description": "Любимые сериалы каждый день в одно и то же время: «Клан Сопрано», «Калифорникейшн», «Декстер», «Борджиа», «Викинги» и другие.\r\nМарафоны сериалов для «запойного» просмотра по выходным. Художественные фильмы каждый день в полночь.",
      "url": "http://amediahit.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "amedia-hit-hd",
      "xvid": 1341,
      "button": "№ кнопки 229",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 3391,
      "title": "Amedia Premium HD",
      "biglogo": "/chbiglogo/1587706167.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665392.png",
      "description": "Премьеры сериалов одновременно с миром: «Игра престолов», «Мир Дикого Запада», «Американская история ужасов», «Викинги», «Твин Пикс», «Шерлок» и другие. Коллекция документальных фильмов, концертов и стендап-шоу. Музыкальные фестивали и церемонии в прямом эфире.",
      "url": "http://amedia.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "amedia-premium-hd",
      "xvid": 40,
      "button": "№ кнопки 221",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 7523,
      "title": "Bolt HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561112162.png",
      "description": "Телеканал российских фильмов. В эфире кино и сериалы о войне, детективы, боевики и приключенческие фильмы. Здесь можно посмотреть «Истребители», «Небо в огне», «Нюхач», «Маэстро» и другие сериалы. Также вас ждут истории создания известных фильмов, обзоры мировых новинок и многое другое.",
      "url": "http://bolt.starmediatv.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "bolt-hd",
      "xvid": 3813,
      "button": "№ кнопки 246",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 4841,
      "title": "Cinema",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1485924286.png",
      "description": "Круглосуточный телеканал с хитами европейского кино. Легендарные фильмы и актеры: «Блеф» с Адриано Челентано, «Васаби» с Жаном Рено, «Сердцеед» с Ванессой Паради.",
      "url": "http://tv-pr.ru/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "cinema",
      "xvid": 256,
      "button": "№ кнопки 238",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 9883,
      "title": "FAN HD",
      "biglogo": "/chbiglogo/1592801687.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1589287244.png",
      "description": "Телеканал анимационного, игрового кино и сериалов в жанре фэнтези — от классических проектов до новинок кинофантастики. Смотрите культовые аниме‑фильмы и сериалы японских киностудий, а также кино и сериалы Китая, Южной Кореи, США и др.",
      "url": "https://fantv.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "fan-hd",
      "xvid": 4743,
      "button": "№ кнопки 250",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 2643,
      "title": "Fox HD",
      "biglogo": "/chbiglogo/1587710397.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1481809650.png",
      "description": "Сериалы разных жанров от мировых студий: «Морская полиция», «Два с половиной человека», «Агенты «ЩИТ», «Готэм», «База Куантико» и другие. Канал показывает премьеры сериалов через несколько часов после релиза в США: «Ходячие мертвецы», «Легион», «Игра престолов», «Изгой».",
      "url": "http://www.fox.com/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "fox-hd",
      "xvid": 109,
      "button": "№ кнопки 207",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 2653,
      "title": "Fox Life HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474881790.png",
      "description": "Телеканал для любителей зарубежных сериалов. Смотрите в формате высокой четкости драму «Мунч», триллер «Иллюзия», детектив «Чикаго в огне». Готовьте с кулинарным богом Джейми Оливером.",
      "url": "http://www.foxtv.ru/shows/foxlife",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "fox-life-hd",
      "xvid": 110,
      "button": "№ кнопки 208",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 2763,
      "title": "Hollywood HD",
      "biglogo": "/chbiglogo/1587709031.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665696.png",
      "description": "Художественные и анимационные фильмы разных лет и жанров киностудии MGM и других голливудских студий.",
      "url": "",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "hollywood-hd",
      "xvid": 3383,
      "button": "№ кнопки 223",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 7533,
      "title": "Paramount Channel HD",
      "biglogo": "/chbiglogo/1587709073.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561112339.png",
      "description": "Киноканал с  фильмами от Paramount Pictures — одной из старейших американских киностудий. В эфире фильмы  разных жанров и эпох — от комедий до мистики, от лент 60-х годов до современных. На канале можно посмотреть фильмы, которые еще не показывали в России.",
      "url": "https://www.paramountchannel.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "paramount-channel-hd",
      "xvid": 2933,
      "button": "№ кнопки 245",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 7513,
      "title": "Star Cinema HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561111984.png",
      "description": "В эфире канала фильмы, сериалы и документальные проекты, созданные на Украине и в странах СНГ. Смотрите в эфире кинокартины «Анна Герман», «Жизнь и приключения Мишки Япончика», «Трава под снегом» и другие. А также документальные проекты — «1812», «Сказание о Крещении Руси», «История Украины».",
      "url": "http://starcinema.starmediatv.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "star-cinema-hd",
      "xvid": 3963,
      "button": "№ кнопки 244",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 7503,
      "title": "Star Family HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561111783.png",
      "description": "Телеканал, где каждый найдет, что посмотреть. Мелодрамы для мамы — «Не торопи любовь», «Другое лицо». Для папы — «Диверсанты» и «Истребители». Собирайтесь у экрана всей семьей и смотрите комедии и познавательные программы.",
      "url": "http://starfamily.starmediatv.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "star-family-hd",
      "xvid": 3833,
      "button": "№ кнопки 243",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6031,
      "title": "TV1000 Action HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487047886.png",
      "description": "Канал для настоящих ценителей остросюжетных фильмов: вас ждут неиссякаемая энергия, адреналин и бесконечный водоворот событий!",
      "url": "https://www.viasat.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "tv1000-action-hd",
      "xvid": 434,
      "button": "№ кнопки 237",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6021,
      "title": "TV1000 HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487047748.png",
      "description": "Культовые мировые киноленты, номинанты и лауреаты известных премий, большое разнообразие жанров и, конечно, тысячи эмоций.",
      "url": "https://www.viasat.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "tv1000-hd",
      "xvid": 433,
      "button": "№ кнопки 236",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6001,
      "title": "TV1000 Русское кино HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487046904.png",
      "description": "Фильмы, которые по праву можно назвать жемчужинами отечественного кинематографа - легендарное советское кино и фильмы современных режиссёров.",
      "url": "https://www.viasat.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "tv1000-russkoe-kino-hd",
      "xvid": 439,
      "button": "№ кнопки 234",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 2253,
      "title": "Zee TV",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474881385.png",
      "description": "Индийский телеканал на русском языке. Смотрите новости Болливуда и душевное кино — «Зита и Гита», «Танцор диско» и другие. Изучайте местную кухню, занимайтесь йогой под руководством гуру и слушайте индийскую музыку.",
      "url": "https://zee-tv.ru/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "zee-tv",
      "xvid": 488,
      "button": "№ кнопки 241",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 129,
      "title": "Дом кино",
      "biglogo": "/chbiglogo/1587710782.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871518.png",
      "description": "Самый успешный российский киноканал, обладающий обширной базой отечественных фильмов и рейтинговых сериалов. В эфире телеканала лучшее российское кино от «Золотого фонда» киностудии «Мосфильм» и других советских киностудий до новейших кинофильмов и громких премьер последнего десятилетия.",
      "url": "http://www.domkino.tv/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "dom-kino",
      "xvid": 72,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 2943,
      "title": "Еврокино",
      "biglogo": "/chbiglogo/1587712969.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502689450.png",
      "description": "Канал европейского кино. Фильмы киностудий Европейского Союза, работы признанных, начинающих и малоизвестных режиссеров.",
      "url": "http://eurokino.tv/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "evrokino",
      "xvid": 99,
      "button": "№ кнопки 212",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 2933,
      "title": "Иллюзион+",
      "biglogo": "/chbiglogo/1587713026.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1481809678.png",
      "description": "Канал зарубежных фильмов и телесериалов разных жанров: комедии, мелодрамы, боевики, фантастика, мультипликация.",
      "url": "http://illusionplus.tv/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "illyuzion-",
      "xvid": 134,
      "button": "№ кнопки 222",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6613,
      "title": "Кино ТВ HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1527069220.jpg",
      "description": "Главный российский телеканал о кино. Более 1500 шедевров: новинки и классика, хиты и андеграунд. Смотрите фильмы Люка Бессона, Скорсезе, Кустурицы, Кончаловского в HD-качестве.",
      "url": "http://www.kinochannel.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "kino-tv-hd",
      "xvid": 2663,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 97,
      "title": "КИНОКОМЕДИЯ",
      "biglogo": "/chbiglogo/1587713116.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1480927674.png",
      "description": "Канал отечественных и зарубежных комедий. Классика жанра и новинки последних лет. Хорошее настроение каждый день!",
      "url": "https://www.nastroykino.ru/kinokomedija/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "kinokomediya",
      "xvid": 155,
      "button": "№ кнопки 211",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 7493,
      "title": "Киномикс HD",
      "biglogo": "/chbiglogo/1587710533.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561104144.png",
      "description": "Особенность канала — тематические показы. Каждую неделю вас ждет новая тема — актеры, режиссеры, страны, фестивали и прочее  — и свежая подборка фильмов к ней. В эфире кино разных жанров — от классики до XXI века.",
      "url": "https://www.nastroykino.ru/kinomiks/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "kinomiks-hd",
      "xvid": 3503,
      "button": "№ кнопки 214",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6643,
      "title": "КИНОСВИДАНИЕ HD",
      "biglogo": "/chbiglogo/1587709778.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520919139.png",
      "description": "Кино для просмотра вдвоем. Романтические комедии, фильмы об историях любви и психологии отношений.",
      "url": "http://www.nastroykino.ru/kinosvidanie/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "kinosvidanie-hd",
      "xvid": 231,
      "button": "№ кнопки 227",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6633,
      "title": "КИНОСЕМЬЯ HD",
      "biglogo": "/chbiglogo/1587709869.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520919164.png",
      "description": "Детское кино и полнометражные мультфильмы, фильмы о дружбе и семейных ценностях. Канал показывает фильмы с повтором в разное время — выберите, когда вам удобно смотреть.",
      "url": "http://www.nastroykino.ru/kinosemja/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "kinosemya-hd",
      "xvid": 124,
      "button": "№ кнопки 218",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 5331,
      "title": "КИНОСЕРИЯ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1480927305.png",
      "description": "Телеканал с современными российскими и зарубежными сериалами. В эфире премьеры и нашумевшие проекты: «Беги!», «Мёртв на 99%», «Виртуозы», «Доктор мафии», «Шефы» и другие хиты в режиме нон-стоп.",
      "url": "http://www.nastroykino.ru/kinoserija/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "kinoseriya",
      "xvid": 186,
      "button": "№ кнопки 242",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6453,
      "title": "Комедия",
      "biglogo": "/chbiglogo/1587709130.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520929574.png",
      "description": "Канал отечественных и зарубежных комедий. Классика жанра и новинки последних лет.",
      "url": "http://komedia-tv.ru/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "komediya",
      "xvid": 2773,
      "button": "№ кнопки 240",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 10081,
      "title": "Мосфильм. Золотая коллекция",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1608614068.png",
      "description": "Золотой фонд отечественного кино от главной студии страны «Мосфильм». Смотрите более 1000 картин советской и российской классики «Мосфильма» и новое современное кино. Теперь такие легенды кино как «Бриллиантовая рука», «Иван Васильевич меняет профессию», «Ирония судьбы, или С легким паром», «Кавказская пленница, или Новые приключения Шурика», «Джентльмены удачи», «Служебный роман» и многие другие будут доступны на отдельном телеканале.",
      "url": "https://mosfilmgold.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "mosfilm-zolotaya-kollektsiya",
      "xvid": 4881,
      "button": "№ кнопки 58",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 93,
      "title": "НАШЕ НОВОЕ КИНО",
      "biglogo": "/chbiglogo/1587713194.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502689309.png",
      "description": "Канал современного российского кино. Фильмы последнего десятилетия, а также премьеры этого года.",
      "url": "http://www.nastroykino.ru/nashe-novoe-kino/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "nashe-novoe-kino",
      "xvid": 238,
      "button": "№ кнопки 215",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 4831,
      "title": "НСТ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474891624.png",
      "description": "Настоящее Страшное Телевидение — телеканал с леденящими кровь ужасами и триллерами. Будет страшно интересно: смотрите «Оно», «Синистер», «Обитель зла» и другие шедевры от мастеров хоррора.",
      "url": "http://strashnoe.tv/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "nst",
      "xvid": 212,
      "button": "№ кнопки 228",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 7543,
      "title": "НТВ Хит",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561112520.png",
      "description": "Телеканал популярных сериалов от НТВ — полицейские расследования, криминальные боевики, комедийные детективы. \r\nВы не пропустите ни одну серию — они повторяются в разное время дня. Смотрите, когда вам удобно.",
      "url": "https://www.ntv.ru/air/ntvhit/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "ntv-khit",
      "xvid": 3423,
      "button": "№ кнопки 247",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 7183,
      "title": "Победа HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1559645029.png",
      "description": "Канал о Великой Отечественной войне. Смотрите классику военного кино, новые фильмы и сериалы, редкие кадры хроники, ранее неизвестные архивные материалы. И, конечно, истории и семейные воспоминания, как приближали День Победы.",
      "url": "",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "pobeda-hd",
      "xvid": 3673,
      "button": "№ кнопки 248",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6433,
      "title": "Русский бестселлер",
      "biglogo": "/chbiglogo/1587712346.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1604057383.png",
      "description": "Золотой фонд сериалов России. Экранизации великих литературных произведений, детективы, приключения, лирические мелодрамы и исторические драмы.",
      "url": "http://www.bestrussia.tv",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "russkiy-bestseller",
      "xvid": 335,
      "button": "№ кнопки 201",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 2923,
      "title": "Русский иллюзион",
      "biglogo": "/chbiglogo/1587984053.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502688861.png",
      "description": "Русские фильмы и сериалы разных лет, передачи о кино, артистах, режиссерах, культовых кинолентах.",
      "url": "http://russkiyillusion.ru/about",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "russkiy-illyuzion",
      "xvid": 343,
      "button": "№ кнопки 230",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6623,
      "title": "Русский роман HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520927983.png",
      "description": "Самый романтичный, эмоциональный, страстный телеканал на отечественном телевидении. Любовь, интриги и неожиданные повороты сюжетов — эти истории не оставят равнодушной ни одну женщину. Основа эфира телеканала — золотая коллекция фильмов, с успехом прошедшая в прайме выходного дня. Круглосуточное вещание телеканала составлено таким образом, что зритель в привычное для себя время не пропустит новинок на канале.",
      "url": "http://rusroman.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "russkiy-roman-hd",
      "xvid": 2713,
      "button": "№ кнопки 200",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 3671,
      "title": "СТС Love",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1515674179.png",
      "description": "Телеканал для романтиков и первооткрывателей. Изучайте физику с «Теорией большого взрыва» и «Галилео», найдите свою вторую половинку на шоу «Сердца за любовь», пересмотрите «Мою прекрасную няню», станьте лучшей мамой с «Супермамочкой».",
      "url": "https://www.ctclove.ru/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "sts-love",
      "xvid": 375,
      "button": "№ кнопки 216",
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 10131,
      "title": "Суббота!",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1612163938.png",
      "description": "Федеральный развлекательный телеканал. Смотрите в эфире культовые сериалы «Зачарованные», «Дикий Ангел», «Сверхъестественное».\r\nПопулярные реалити-шоу «Подиум», «Топ-модель», «Богиня шопинга», «Аферисты в сетях». А также любимое кино: «Дневник Бриджит Джонс», «Дьявол носит Прада», «Война Невест» и другие.",
      "url": "",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "subbota",
      "xvid": 2703,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 4571,
      "title": "2x2",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1629278065.png",
      "description": "В эфире взрослая анимация, нестандартные сериалы и кинофильмы, наука, искусство и гейминг. Телеканал состоит из тематических блоков от кураторов, которые рассказывают, что и почему стоит посмотреть.",
      "url": "http://2x2tv.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "2x2",
      "xvid": 20,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 7483,
      "title": "7tv",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561102637.png",
      "description": "Российский развлекательный телеканал. В эфире психологические, мистические, детективные фильмы и сериалы, документальные программы об устройстве Вселенной, программы о психологии и психологические ток-шоу.",
      "url": "http://7-tv.tv/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "7tv",
      "xvid": 3783,
      "button": "№ кнопки 34",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 4591,
      "title": "LEOMAX+",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1583495771.png",
      "description": "Канал «LEOMAX+» – современный телеканал самых выгодных цен 24 часа в сутки, 7 дней в неделю. В прямом эфире ведущие подробно и увлекательно расскажут о качестве товара. Каждый день телезрителей ждут новинки и удивительные акции.",
      "url": "https://diskont-tv.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "leomax-",
      "xvid": 2563,
      "button": "№ кнопки 55",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 6343,
      "title": "Leomax24",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1586250980.png",
      "description": "Современный телемагазин самых выгодных цен 24 часа в сутки, 7 дней в неделю. В прямом эфире ведущий и эксперт подробно, увлекательно и честно расскажут о качестве товара. Каждый день покупателей ждут новинки, удивительные акции и приятное общение.",
      "url": "https://www.leomax24.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "leomax24",
      "xvid": 1321,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 3541,
      "title": "MTV HD",
      "biglogo": "/chbiglogo/1633002296.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1633001942.png",
      "description": "Молодежный развлекательный канал. В эфире современные развлекательные программы и сериалы, популярные реалити-шоу, музыкальный блок. У канала эксклюзивные права на показ крупнейших церемоний MTV EMA, MTV VMA, Isle of MTV Malta.",
      "url": "http://www.mtv.ru/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "mtv-hd",
      "xvid": 189,
      "button": "№ кнопки 305",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 2773,
      "title": "myZen.tv HD",
      "biglogo": "/chbiglogo/1587709272.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474881834.png",
      "description": "Йога, медитация, массаж, релаксация, спа, фитнес, путешествия, семейные поездки, съемки самых красивых уголков планеты. Экономьте время на походах в спортзал, выполняя упражнения из различных практик вместе с профессиональными тренерами myZen.tv.",
      "url": "http://www.myzen.tv/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "myzentv-hd",
      "xvid": 198,
      "button": "№ кнопки 304",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 3381,
      "title": "Paramount Comedy HD",
      "biglogo": "/chbiglogo/1629278582.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1629278582.png",
      "description": "Лучшие комедийные сериалы, самые удачные скетчи, российский и зарубежный стендап — Paramount Comedy показывает все, что смешно. «Теория большого взрыва» и «Как я встретил вашу маму» по версии Кураж-Бамбей, «Южный парк» в озвучке Евгения Рыбова, «Друзья», «Бруклин 9-9», «Голдберги», «Детство Шелдона».",
      "url": "http://paramountcomedy.ru/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "paramount-comedy-hd",
      "xvid": 255,
      "button": "№ кнопки 302",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 5121,
      "title": "Shop&Show",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474892007.png",
      "description": "Телемагазин с товарами для дома и красоты. Покупайте в удобное время прямо из дома — платье, серьги, аэрогриль, электропилу, парфюм и планшет. Магазин предлагает товары на все случаи жизни.",
      "url": "http://shopandshow.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "shopshow",
      "xvid": 1541,
      "button": "№ кнопки 50",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 2853,
      "title": "Shopping Live",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474883751.png",
      "description": "Немецкий телемагазин с товарами на все случаи жизни. Обновите гардероб, поменяйте шторки в ванной, закажите на кухню раклетницу-гриль, а на дачу — гамак, не вставая с дивана. Покупайте, когда удобно.",
      "url": "http://www.shoppinglive.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "shopping-live",
      "xvid": 349,
      "button": "№ кнопки 43",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 3551,
      "title": "TLC HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886039.png",
      "description": "Узнайте, как женятся цыгане в США, какие платья подойдут пышным невестам, как обустроиться на Багамах и можно ли вести бизнес без одежды — все это в реалити-шоу о моде и стиле жизни, здоровье и отношениях.",
      "url": "http://www.tlc-tv.ru/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "tlc-hd",
      "xvid": 397,
      "button": "№ кнопки 309",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 78,
      "title": "World Fashion Channel HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871156.png",
      "description": "Телеканал для модников и модниц. Смотрите неделю моды в Милане, трансляцию с Каннского кинофестиваля, узнавайте о трендах сезона и секретах стиля селебрити. В формате HD — еще ярче и реалистичнее.",
      "url": "https://wfc.tv/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "world-fashion-channel-hd",
      "xvid": 486,
      "button": "№ кнопки 314",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 3851,
      "title": "Дом.ru Гид HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1637903832.png",
      "description": "В эфире анонсы телепередач и обновления в сети Дом.ru, курсы валют, прогноз погоды, конкурсы, акции и фильмы. Канал познакомит с дополнительными сервисами, научит подключать и использовать ТВ-приставки, ответит на самые частые вопросы клиентов.",
      "url": "https://perm.dom.ru/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "domru-gid-hd",
      "xvid": 1091,
      "button": "№ кнопки 40",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 6061,
      "title": "ЖАРА",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1490937530.png",
      "description": "Телеканал с музыкальными хитами и живыми концертами. Какой новый трек записал Ганвест, на какую песню последний клип Ёлки, где на прошлой неделе прошла самая жаркая пати — узнайте на «Жаре».",
      "url": "http://zhara.tv/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "zhara",
      "xvid": 57,
      "button": "№ кнопки 313",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 3861,
      "title": "Живи",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886460.png",
      "description": "Занимайтесь спортом дома под руководством профессиональных фитнес-тренеров. Освойте стретчинг, пилатес и боди-балет, изучите йогу с нуля. Узнайте, что нужно есть, чтобы похудеть, и как готовить полезную и вкусную пищу.",
      "url": "https://www.jv.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "zhivi",
      "xvid": 144,
      "button": "№ кнопки 311",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 6041,
      "title": "КВН ТВ",
      "biglogo": "/chbiglogo/1587710924.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487048196.png",
      "description": "В эфире игры Высшей и Премьер-лиги КВН, фестивали в Юрмале и Сочи, программы о КВН, репортажи с мероприятий клуба, передачи с участием звезд КВН и российского шоу-бизнеса.",
      "url": "http://kvn.ru/tv",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "kvn-tv",
      "xvid": 2161,
      "button": "№ кнопки 301",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 192,
      "title": "Кухня ТВ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871870.png",
      "description": "Телеканал для гурманов. Готовьте полезный фастфуд, изучайте кухню Южной Африки и Новой Каледонии, записывайте рецепты знаменитых шеф-поваров. В эфире гастрономические мастер-классы, трэвел-шоу, сериалы на тему кулинарии.",
      "url": "http://www.kuhnyatv.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "kukhnya-tv",
      "xvid": 158,
      "button": "№ кнопки 308",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 277,
      "title": "Ностальгия",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474872188.png",
      "description": "Телеканал о кумирах и событиях прошлого. Узнайте, что случилось в этот день 30 лет назад, слушайте песни «Битлз» и Визбора, смотрите концерты Миронова, передачи прошлых лет и фильмы о легендах музыки и кино.",
      "url": "http://www.nostalgiatv.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "nostalgiya",
      "xvid": 211,
      "button": "№ кнопки 310",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 6603,
      "title": "НТВ HD",
      "biglogo": "/chbiglogo/1587710982.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520926946.png",
      "description": "Информационные программы, сенсационные репортажи, ток-шоу, остросюжетные художественные фильмы и сериалы.",
      "url": "http://www.ntv.ru/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "ntv-hd",
      "xvid": 2653,
      "button": "№ кнопки 60",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 3163,
      "title": "Первый HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474885220.png",
      "description": "Главный телеканал страны в суперчетком изображении. «Модный приговор», «Вечерний Ургант», любимые герои и сериалы — еще ярче и реалистичнее. Смотрите новости, кино, ток-шоу и спортивные трансляции.",
      "url": "http://www.1tv.ru/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "pervyy-hd",
      "xvid": 10,
      "button": "№ кнопки 41",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 6593,
      "title": "РЕН ТВ HD",
      "biglogo": "/chbiglogo/1587711001.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1528089758.png",
      "description": "В эфире канала — развлекательные реалити‑шоу, остросюжетные фильмы и сериалы, информационные программы, познавательные передачи, кинодокументалистика.",
      "url": "http://ren.tv/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "ren-tv-hd",
      "xvid": 2583,
      "button": "№ кнопки 59",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 2963,
      "title": "Россия HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474883917.png",
      "description": "Смотрите «Утро России», «Вести» и ток-шоу Андрея Малахова в формате высокой четкости. Играйте в «Сто к одному», смейтесь над шутками Евгения Петросяна, сопереживайте героям фильмов и сериалов.",
      "url": "http://russiahd.tv/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "rossiya-hd",
      "xvid": 300,
      "button": "№ кнопки 42",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 6311,
      "title": "Сарафан",
      "biglogo": "/chbiglogo/1587712287.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1499413643.png",
      "description": "100 часов юмористических программ и 30 часов скетч-шоу еженедельно. 10 часов нового контента каждую субботу. Классики юмора: Евгений Петросян, Елена Степаненко, Лион Измайлов и другие. В эфире «Кривое зеркало», «Смехопанорама», «Клуб юмора», «Аншлаг».",
      "url": "http://sarafan-tv.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "sarafan",
      "xvid": 1861,
      "button": "№ кнопки 312",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 2793,
      "title": "Телекафе",
      "biglogo": "/chbiglogo/1587715478.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1559294732.png",
      "description": "Кулинарно-развлекательный канал: вкусно, весело, полезно. Готовьте по рецептам российских звёзд вместе с программой «Смак», наблюдайте за жизнью ресторана изнутри в сериале «Кухня», узнайте, как всегда быть в форме без диет с шоу «Минимум калорий».",
      "url": "https://www.telecafe.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "telekafe",
      "xvid": 391,
      "button": "№ кнопки 307",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 5971,
      "title": "ТНТ HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487045985.png",
      "description": "Федеральный канал развлекательной тематики в HD формате. В сетке вещания представлены комедийные сериалы, реалити-шоу,юмористические шоу и  художественные фильмы.",
      "url": "http://www.tnt-tv.ru/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "tnt-hd",
      "xvid": 2241,
      "button": "№ кнопки 57",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 682,
      "title": "ТНТ4",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474873106.png",
      "description": "Телеканал, который поднимает настроение. Смотрите шоу Comedy Club, Comedy Woman и «Наша Russia», комедийные сериалы «Зайцев+1», «Универ» и «Счастливы вместе». Положительных эмоций добавит комедийная мелодрама «Улица».",
      "url": "http://tnt4.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "tnt4",
      "xvid": 1561,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 5141,
      "title": "Че",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1599650394.png",
      "description": "Канал для любителей приключений.  Смотрите культовые сериалы, наблюдайте за «Дорожными войнами», научитесь бороться с мошенниками с «Решалой», разоблачайте обманщиков с «Опасными связями».",
      "url": "https://chetv.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "che",
      "xvid": 1371,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 2823,
      "title": "Ю",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1525432881.jpg",
      "description": "Женский телеканал о красоте и отношениях. Узнайте, как правильно худеть, с проектом «Взвешенные и счастливые», научитесь ладить с его мамой с помощью шоу «Моя свекровь — монстр». Смотрите культовые сериалы «Клон» и «Тропикана».",
      "url": "https://www.u-tv.ru/#",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "yu",
      "xvid": 457,
      "button": "№ кнопки 25",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 5961,
      "title": "Ювелирочка",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1608022633.png",
      "description": "Телемагазин ювелирных украшений. Делайте подарки, не выходя из дома: супруге — браслет с изумрудами, мужу — кольцо-печатку, дочке — пусеты с топазом. Есть даже уникальные изделия.",
      "url": "",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "yuvelirochka",
      "xvid": 1151,
      "button": "№ кнопки 26",
      "bids": 92,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 7553,
      "title": "365 Дней",
      "biglogo": "/chbiglogo/1587713232.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561112868.png",
      "description": "Учебник истории на вашем экране. В эфире канала программы, документальные циклы и фильмы об истории России и мира. Изучайте и анализируйте исторические события, знакомьтесь с великими людьми прошлого и их судьбами.",
      "url": "https://www.365days.ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "365-dney",
      "xvid": 3473,
      "button": "№ кнопки 416",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 1902,
      "title": "Animal Planet",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1563775106.png",
      "description": "Побывайте в неизведанных уголках планеты с телеканалом о мире животных. Спасайте орангутанов, плавайте с анакондами, знакомьтесь с пингвинами и акулами вместе с отважными ведущими зоо-шоу.",
      "url": "http://www.discoverychannel.ru/shows/animal-planet/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "animal-planet",
      "xvid": 41,
      "button": "№ кнопки 401",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 7003,
      "title": "Da Vinci",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1605010260.png",
      "description": "Это Вселенная знаний и открытий для детей и их родителей. Предлагаем вам целый мир познавательных телешоу, документальных фильмов, игр и мультфильмов.",
      "url": "https://www.davincikids.tv/ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "da-vinci",
      "xvid": 62,
      "button": "№ кнопки 409",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 1912,
      "title": "Discovery Channel HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1566908908.png",
      "description": "Телеканал для искателей приключений. Добывайте золото на Клондайке, ищите сокровища с «Охотниками за складами», исследуйте Марс и спасайтесь от похитителей на мексиканской границе.",
      "url": "http://www.discoverychannel.ru/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "discovery-channel-hd",
      "xvid": 219,
      "button": "№ кнопки 402",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 3571,
      "title": "Discovery Science HD",
      "biglogo": "/chbiglogo/1587710774.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1481809290.png",
      "description": "Международный канал о науке и технике, исследованиях и открытиях. История изобретений и технические новинки, строение организма и тайны Вселенной, смелые гипотезы и сенсационные разоблачения.",
      "url": "http://www.discoverychannel.ru/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "discovery-science-hd",
      "xvid": 225,
      "button": "№ кнопки 403",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6131,
      "title": "DocuBox HD",
      "biglogo": "/chbiglogo/1587711825.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487049915.png",
      "description": "Документальный канал, который показывает фильмы, сериалы и программы о дикой природе, науке, человечестве и мировой культуре.",
      "url": "",
      "hd": 1,
      "thid": 7,
      "display": 1,
      "alias": "docubox-hd",
      "xvid": 2261,
      "button": "№ кнопки 434",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 2082,
      "title": "English Club HD",
      "biglogo": "/chbiglogo/1587710182.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474874302.png",
      "description": "Канал для тех, кто изучает английский язык. Эфир — это коллекция развлекательных и познавательных сюжетов для погружения в языковую среду. Программы канала развивают навыки чтения, разговорной речи, понимания речи на слух, способствуют преодолению языкового барьера.",
      "url": "http://english-club.tv/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "english-club-hd",
      "xvid": 96,
      "button": "№ кнопки 417",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6161,
      "title": "Galaxy",
      "biglogo": "/chbiglogo/1587711860.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487050566.png",
      "description": "Первый российский научно-фантастический канал о космосе и авиации, развитии воздухоплавания и астронавтики, исследованиях земной атмосферы и космического пространства.",
      "url": "http://galaxy-tv.ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "galaxy",
      "xvid": 1941,
      "button": "№ кнопки 437",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 7563,
      "title": "HD Life",
      "biglogo": "/chbiglogo/1587715506.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561113125.png",
      "description": "Телеканал о физических и интеллектуальных возможностях человека, окружающем мире, природе и Вселенной. Программы поделены по темам: «Человек», «Земля», «Вселенная». У каждой темы свой цвет. Смотрите, что нравится: красный – программы о Человеке и его возможностях, фиолетовый – о тайнах Вселенной, зеленый – о Земле и многообразии жизни.",
      "url": "https://www.hdlife.ru/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "hd-life",
      "xvid": 123,
      "button": "№ кнопки 420",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 9953,
      "title": "HGTV",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1589289012.png",
      "description": "Телеканал о канал о доме, дизайне, прикладном декорировании, ремонте, домашнем уюте и красоте, окружающей жизнь человека.",
      "url": "https://watch.hgtv.com/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "hgtv",
      "xvid": 4813,
      "button": "№ кнопки 430",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6141,
      "title": "Museum HD",
      "biglogo": "/chbiglogo/1587715422.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1554790787.png",
      "description": "Канал об изобразительном искусстве. Узнайте о последних мировых выставках, окунитесь в историю музеев и экспонатов, познакомьтесь с современными видами искусства, следите за аукционами и смотрите, как создаются шедевры архитектуры.",
      "url": "http://www.themuseumchannel.tv/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "museum-hd",
      "xvid": 1621,
      "button": "№ кнопки 435",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 2613,
      "title": "National Geographic HD",
      "biglogo": "/chbiglogo/1587712421.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1564654738.png",
      "description": "Программы о животном и растительном мире, истории, жизни людей в разных странах, науках о Земле.",
      "url": "http://www.natgeotv.com/ru",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "national-geographic-hd",
      "xvid": 206,
      "button": "№ кнопки 400",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 1132,
      "title": "National Geographic Wild HD",
      "biglogo": "/chbiglogo/1587711021.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1554108178.png",
      "description": "Телеканал о дикой природе, окружающей среде и удивительных существах, живущих на Земле.",
      "url": "http://www.natgeotv.com/ru/shows/natgeowild",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "national-geographic-wild-hd",
      "xvid": 204,
      "button": "№ кнопки 405",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6111,
      "title": "RTG HD",
      "biglogo": "/chbiglogo/1587711809.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487049630.png",
      "description": "Познавательный канал о России: природа, животный мир, активный отдых, охота и рыбалка, круизы и экскурсии, прогулки по городам, люди, культура, религия, история, кухня, наука и техника, курорты.",
      "url": "http://rtgtv.ru/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "rtg-hd",
      "xvid": 2191,
      "button": "№ кнопки 432",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 10391,
      "title": "Russia Today Doc HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1633597110.png",
      "description": "В эфире канала документальные фильмы о России и мире. Посетите подземное царство Кунгура, узнайте тайны Валаама, погрузитесь на дно норвежского фьорда в поисках сокровищ затонувших кораблей.",
      "url": "https://doc.rt.com/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "russia-today-doc-hd",
      "xvid": 295,
      "button": "№ кнопки 422",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 42,
      "title": "Viasat Explore",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474870985.png",
      "description": "Развлекательный телеканал о захватывающих приключениях и путешествиях, необычных профессиях и неординарных людях – героях нашего времени.",
      "url": "http://www.viasat.su/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "viasat-explore",
      "xvid": 103,
      "button": "№ кнопки 424",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 24,
      "title": "Viasat History",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474870835.png",
      "description": "Окно в мир истории. Совершите путешествие во времени по самым темным и потаённым уголкам Истории с авторитетными историками и достоверными программами.",
      "url": "http://www.viasat.su/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "viasat-history",
      "xvid": 130,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 1892,
      "title": "Viasat Nature",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474874201.png",
      "description": "Это голос самой природы. Канал представляет рассказы учёных и очевидцев о прекрасных растениях и невероятных созданиях, населяющих нашу планету.",
      "url": "http://www.viasat.su ",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "viasat-nature",
      "xvid": 205,
      "button": "№ кнопки 425",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 5751,
      "title": "Viasat Nature/History HD",
      "biglogo": "/chbiglogo/1587715446.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1556086589.png",
      "description": "Два канала на одной кнопке: с 19:00 до 07:00 (мск) вас ждут разгадки тайн истории, с 07:00 до 19:00 (мск) вы совершите путешествие в мир природы.",
      "url": "http://www.myviasat.ru",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "viasat-naturehistory-hd",
      "xvid": 477,
      "button": "№ кнопки 419",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 5511,
      "title": "Бобер",
      "biglogo": "/chbiglogo/1587710629.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474892503.png",
      "description": "Канал о современном дизайне и решениях, которые помогут создать уют в доме, офисе и на даче. Ведущие канала — дизайнеры интерьеров, архитекторы, строители, ландшафтные специалисты. Они рассказывают и показывают как обустроить пространство своими руками.",
      "url": "http://www.bober-tv.ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "bober",
      "xvid": 1251,
      "button": "№ кнопки 427",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 5501,
      "title": "В мире животных ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1515673880.jpg",
      "description": "Узнайте, о чем думают животные, как проходит день в зверином детском саду и может ли собака управлять самолетом. Погрузитесь в мир дикой природы с головой благодаря формату HD.",
      "url": "http://animalfamily.tv/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "v-mire-zhivotnykh",
      "xvid": 1661,
      "button": "№ кнопки 413",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6493,
      "title": "Дикая охота HD",
      "biglogo": "/chbiglogo/1587712386.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520928924.png",
      "description": "Для начинающих и опытных охотников. Рассказы об охоте, тестирование снаряжения и оружия, охотничья кулинария, подводная охота, фотоохота, новинки охотничьего снаряжения, приключения и путешествия в разные уголки земного шара.",
      "url": "http://dikoe.tv/channels/dikaya-okhota-hd.html",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "dikaya-okhota-hd",
      "xvid": 2633,
      "button": "№ кнопки 438",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6503,
      "title": "Дикая рыбалка HD",
      "biglogo": "/chbiglogo/1587712410.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520928940.png",
      "description": "Мастер-классы рыболовов-экспертов, рассказы о рыбной ловле, тестирование снастей, рыболовная кулинария, летняя и зимняя рыбалка, новинки в мире рыболовного снаряжения, приключения человека в дикой природе.",
      "url": "http://dikoe.tv/channels/dikaya-rybalka-hd.html",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "dikaya-rybalka-hd",
      "xvid": 2623,
      "button": "№ кнопки 431",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6563,
      "title": "Доктор HD",
      "biglogo": "/chbiglogo/1587714490.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1604057226.png",
      "description": "Канал о достижениях медицины, новых методах диагностики и лечения болезней.",
      "url": "http://doc-tv.ru/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "doktor-hd",
      "xvid": 2723,
      "button": "№ кнопки 404",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6583,
      "title": "Живая Планета",
      "biglogo": "/chbiglogo/1587714518.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520929836.png",
      "description": "Канал о природе России. Исследования дикой природы, экспедиции, редкие животные, реалити о волонтерских центрах и работе ветеринарных врачей, обучающие программы для детей и родителей, шоу о том, как выбрать питомца.",
      "url": "http://www.live-planet.tv",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "zhivaya-planeta",
      "xvid": 2573,
      "button": "№ кнопки 426",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 572,
      "title": "Загородная жизнь",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474872987.png",
      "description": "Телеканал для садоводов и огородников. Следите за «Битвой теплиц», узнайте, чем обсадить пруд в тенистом месте, какое удобрение любят розы и как приготовить мыло из трав. В эфире — советы и мастер-классы.",
      "url": "http://zagorod-tv.ru",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "zagorodnaya-zhizn",
      "xvid": 487,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 4851,
      "title": "История",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1494591911.jpg",
      "description": "Узнайте тайны Курской битвы и тонкости погребальных ритуалов инков, познакомьтесь с обычаями самураев. В эфире канала программы и документальные фильмы о выдающихся событиях, личностях, артефактах прошлого.",
      "url": "http://istoriya.tv/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "istoriya",
      "xvid": 140,
      "button": "№ кнопки 421",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 9923,
      "title": "Ключ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1589288486.png",
      "description": "Канал о реальной жизни. В эфире программы собственного производства, премьерные зарубежные шоу и немного кино.\r\nУзнайте, с чего начать свой бизнес, и сколько это стоит в программе «Задело». Путешествуйте по Европе вместе с интернет-знаменитостями без денег, телефонов и интернета. Цикл передач «Профессии будущего» расскажет куда пойти учиться, чтобы хорошо зарабатывать, и какие профессии будут востребованы завтра. А также в эфире советы, как тратить деньги с умом, готовить полезные и вкусные обеды на работу и многое другое.",
      "url": "https://kluch.tv/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "klyuch",
      "xvid": 4103,
      "button": "№ кнопки 410",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 3661,
      "title": "Мама",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886241.png",
      "description": "Телеканал-помощник для мам. Узнайте у доктора Комаровского, как избавить малыша от колик, смотрите программы о красоте и здоровье, воспитании детей и семейных взаимоотношениях, научитесь готовить вкусно и полезно в кулинарных шоу.",
      "url": "http://mama.tlum.ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "mama",
      "xvid": 187,
      "button": "№ кнопки 415",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 1242,
      "title": "Моя Планета",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474873980.png",
      "description": "Путешествуйте, изучайте и открывайте: что продают на рынках в Македонии и Астрахани, как устроено зрение и супермозг, кого называют шпионами в дикой природе. Приключения и исследования в режиме нон-стоп.",
      "url": "https://www.moya-planeta.ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "moya-planeta",
      "xvid": 199,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 9683,
      "title": "Моя Планета HD",
      "biglogo": "/chbiglogo/1587715596.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1575272890.png",
      "description": "Путешествуйте, изучайте и открывайте: что продают на рынках в Македонии и Астрахани, как устроено зрение и супермозг, кого называют шпионами в дикой природе. Приключения и исследования в режиме нон-стоп.",
      "url": "https://www.moya-planeta.ru/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "moya-planeta-hd",
      "xvid": 4153,
      "button": "№ кнопки 436",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 2863,
      "title": "Наука",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1604057191.png",
      "description": "Телеканал о научных открытиях, технологиях и разработках. Узнайте, возможны ли путешествия во времени, на самом ли деле полезны витамины, что скрывает Крымская Атлантида и существует ли лекарство от глупости.",
      "url": "http://www.naukatv.ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "nauka",
      "xvid": 207,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 5891,
      "title": "Оружие",
      "biglogo": "/chbiglogo/1587712300.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502689055.png",
      "description": "Первый в России телеканал об оружии. Все виды оружия и его история, оружие как часть мировой культуры, армии мира и боевые техники. Около 1000 часов документальных программ и фильмов, снятых в России и за рубежом.",
      "url": "http://www.oruzhie.tv/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "oruzhie",
      "xvid": 631,
      "button": "№ кнопки 429",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 3033,
      "title": "Охотник и рыболов HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1481809758.png",
      "description": "Телеканал покажет самые рыбные места в Беларуси и видеокарты уловистых мест.  Вы узнаете, как использовать спиннинг, какие приемы помогут в охоте на глухаря и как вкусно приготовить дичь.",
      "url": "http://www.ohotnikirybolov.tv/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "okhotnik-i-rybolov-hd",
      "xvid": 248,
      "button": "№ кнопки 412",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6673,
      "title": "Первый вегетарианский",
      "biglogo": "/chbiglogo/1587714623.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1521092672.png",
      "description": "Уникальный познавательно-развлекательный телеканал, посвященный теме вегетарианства и ведения здорового образа жизни. Телеканал будет интересен вегетарианцам, веганам, сыроедам и всем, кто интересуется здоровым питанием и здоровым образом жизни.",
      "url": "https://www.1veg-tv.ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "pervyy-vegetarianskiy",
      "xvid": 2593,
      "button": "№ кнопки 428",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6573,
      "title": "Поехали!",
      "biglogo": "/chbiglogo/1587714553.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520929932.png",
      "description": "Телеканал о ярких и незабываемых приключениях по России и ближнему зарубежью. \r\nКанал для тех, кто хочет путешествовать по России, узнать о своей стране, природе разных регионов, памятниках истории и культуры, людях. В программах канала — свежая точка зрения на внутренний туризм, информация о маршрутах, экскурсиях и ценах.",
      "url": "http://www.poehali.tv/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "poekhali",
      "xvid": 2613,
      "button": "№ кнопки 433",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 862,
      "title": "Приключения HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1512993854.jpg",
      "description": "Телеканал для любителей острых ощущений. Укрощайте крокодилов в Австралии, останьтесь один на один с дикой природой, узнайте, может ли человек выжить в пустыне и открытом море.",
      "url": "http://www.teletravelhd.tv/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "priklyucheniya-hd",
      "xvid": 394,
      "button": "№ кнопки 418",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 5461,
      "title": "Т24",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1604057357.png",
      "description": "Телеканал о мужских увлечениях. Разберите физику боя, узнайте, как работают горные спасатели, пройдите от полюса до полюса и прокачайте навыки строительства — все это на основе реальных событий.",
      "url": "http://www.techno24.tv/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "t24",
      "xvid": 390,
      "button": "№ кнопки 423",
      "bids": 92,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 692,
      "title": "Eurosport 1 HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1481809627.png",
      "description": "Смотрите «Тур де Франс», автогонки в Вила-Реале, конный чемпионат LGCT, кубок мира по стрельбе из лука, Australian Open по настольному теннису и другие мировые турниры в HD-качестве.",
      "url": "http://www.eurosport.ru/",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "eurosport-1-hd",
      "xvid": 102,
      "button": "№ кнопки 500",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 3871,
      "title": "Eurosport 2 HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886472.png",
      "description": "Смотрите «Уимблдон», «Тур де Франс», автогонки, соревнования по клифф-дайвингу и гребному слалому, футбольные и хоккейные чемпионаты — весь мировой спорт в формате HD.",
      "url": "http://www.eurosport.ru/",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "eurosport-2-hd",
      "xvid": 98,
      "button": "№ кнопки 501",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 7573,
      "title": "M-1 Global HD",
      "biglogo": "/chbiglogo/1638772727.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1638772727.png",
      "description": "Телеканал ММА-ТV.соm (новое имя M-1 Global) – уникальный тематический телеканал, посвященный MMA. Контент: прямые трансляции турниров MMA Серии, турниры по MMA международных лиг, новостные и авторские программы, фильмы о бойцах и развитии российского и мирового MMA. \r\nMMA-TV.com – бренд, целевой аудиторией которого являются поклонники MMA. Трансляция круглосуточная, на двух языках (рус, англ).",
      "url": "https://m-1global.com/tv",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "m-1-global-hd",
      "xvid": 3483,
      "button": "№ кнопки 511",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 87,
      "title": "Авто Плюс",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871222.png",
      "description": "Телеканал для любителей авто. Следите за Формулой-1, смотрите британское шоу Top Gear, узнайте, на что обратить внимание при покупке машины и чем Hyundai Solaris лучше Volkswagen Polo.",
      "url": "http://www.autoplustv.ru/",
      "hd": 0,
      "thid": 10,
      "display": 3,
      "alias": "avto-plyus",
      "xvid": 44,
      "button": "№ кнопки 504",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 3701,
      "title": "АВТО24 HD",
      "biglogo": "/chbiglogo/1587712332.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502689416.png",
      "description": "Канал об авто: прямые трансляции российских и мировых чемпионатов, новости автомобильного мира, спецпроекты и интервью.",
      "url": "http://avto24tv.ru/",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "avto24-hd",
      "xvid": 46,
      "button": "№ кнопки 505",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 5911,
      "title": "Бокс ТВ",
      "biglogo": "/chbiglogo/1587710731.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1479383275.png",
      "description": "Трансляция 90% мировых топ-боксерских поединков. Интервью спортсменов и тренеров, эксклюзивные бои, свежие новости и события профессионального бокса.",
      "url": "http://boxingtv.ru/",
      "hd": 0,
      "thid": 10,
      "display": 3,
      "alias": "boks-tv",
      "xvid": 1521,
      "button": "№ кнопки 514",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 5901,
      "title": "Драйв",
      "biglogo": "/chbiglogo/1587710695.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1479383090.png",
      "description": "Канал об автомобилях, мотоциклах и путешествиях. Тест-драйвы, репортажи с выставок и автосалонов, история гигантов автопрома, автоспорт, автотуризм, безопасность на дороге, уроки вождения и многое другое.",
      "url": "http://drive-tv.ru/",
      "hd": 0,
      "thid": 10,
      "display": 3,
      "alias": "drayv",
      "xvid": 1741,
      "button": "№ кнопки 520",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 5171,
      "title": "МАТЧ! HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1573036348.png",
      "description": "Смотрите Кубок Африки по футболу, волейбольную Лигу наций, ралли «Шелковый путь», шахматные турниры и прыжки в воду. Все виды спорта и главные мировые события в HD-качестве.",
      "url": "http://matchtv.ru/",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "match-hd",
      "xvid": 1481,
      "button": "№ кнопки 508",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 4121,
      "title": "МАТЧ! АРЕНА HD",
      "biglogo": "/chbiglogo/1587708448.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886984.png",
      "description": "Самые престижные мировые турниры в прямом эфире: Олимпийские Игры, Чемпионаты мира и Европы по легкой атлетике, биатлону, лыжным гонкам, фигурному катанию, водным видам спорта и другие.",
      "url": "https://matchtv.ru/matchtv_thematic_channels",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "match-arena-hd",
      "xvid": 1581,
      "button": "№ кнопки 506",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 5241,
      "title": "МАТЧ! БОЕЦ",
      "biglogo": "/chbiglogo/1587708545.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474892139.png",
      "description": "В эфире канала — профессиональные и любительские единоборства: бокс, смешанные единоборства, кикбоксинг, дзюдо, борьба, самбо и другие. Прямые трансляции зрелищных боев мира с участием российских и зарубежных спортсменов.",
      "url": " http://www.boets.ru/",
      "hd": 0,
      "thid": 10,
      "display": 3,
      "alias": "match-boets",
      "xvid": 51,
      "button": "№ кнопки 503",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 4001,
      "title": "МАТЧ! ИГРА HD",
      "biglogo": "/chbiglogo/1587708607.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886639.png",
      "description": "Рейтинговые мировые турниры в прямом эфире: Европейские клубные турниры  по баскетболу, волейболу, гандболу, теннису и другим игровым групповым видам спорта.",
      "url": "https://perm.domru.ru/domru-tv/channel/4001",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "match-igra-hd",
      "xvid": 1591,
      "button": "№ кнопки 509",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 471,
      "title": "МАТЧ! СТРАНА",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1551702247.jpg",
      "description": "В эфире канала идут наиболее интересные российские турниры: чемпионаты страны по легкой атлетике, плаванию, спортивной и художественной гимнастике, биатлону, волейболу, гандболу, баскетбольные матчи Единой Лиги ВТБ, а также международные соревнования, проходящие на территории России.",
      "url": "https://matchtv.ru/matchtv_thematic_channels",
      "hd": 0,
      "thid": 10,
      "display": 3,
      "alias": "match-strana",
      "xvid": 1601,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 5921,
      "title": "Моторспорт ТВ",
      "biglogo": "/chbiglogo/1587714653.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1538404506.png",
      "description": "15 лет канал делает трансляции и обзоры известных авто и мото чемпионатов. В эфире документальные фильмы, интервью со звездами спорта, передачи о самых быстрых и самых дорогих машинах в мире и еще много интересного.",
      "url": "https://www.motorstv.com/",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "motorsport-tv",
      "xvid": 3073,
      "button": "№ кнопки 507",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 86,
      "title": "Русский экстрим HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871211.png",
      "description": "Смотрите всемирные экстремальные игры X-Games, чемпионаты по мотофристайлу, дрифтингу и паркуру. Получайте острые ощущения с экстрим-шоу и динамичными фильмами — «Адреналин», «Перевозчик», «Риддик».",
      "url": "http://www.extremtv.ru/",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "russkiy-ekstrim-hd",
      "xvid": 342,
      "button": "№ кнопки 516",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 10181,
      "title": "Футбол",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1618466182.png",
      "description": "Смотрите в эфире канала матчи европейских чемпионатов — Чемпионшип, Английская Лига 1, Английская Лига 2, Чемпионат Голландии. А также Кубки и товарищеские встречи, интервью со звездами мирового футбола, репортажи о жизни команд и исторические матчи прошлого.",
      "url": "https://www.football-tv.ru/",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "futbol",
      "xvid": 1771,
      "button": "№ кнопки 521",
      "bids": 92,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 5531,
      "title": "Ani",
      "biglogo": "/chbiglogo/1587706453.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474892526.png",
      "description": "Для детей 6-12 лет. В эфире мультфильмы из разных стран мира. Среди них уже знакомые нашим детям «Шарлотта‑Земляничка», «Веселые паровозики из Чаддингтона», «Пингвиненок Пороро», «Катя и Мим-Мим», «Леонардо», «Тайо маленький автобус» и другие.",
      "url": "http://ani.tlum.ru/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "ani",
      "xvid": 1241,
      "button": "№ кнопки 603",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 3471,
      "title": "Baby TV",
      "biglogo": "/chbiglogo/1587706541.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474885962.png",
      "description": "Канал для детей до 3-х лет на английском языке. Малыш может петь, играть, рисовать, слушать истории, учиться читать, считать, общаться и познавать.\r\nКанал показывает без рекламы.",
      "url": "http://www.babytv.com/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "baby-tv",
      "xvid": 48,
      "button": "№ кнопки 611",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 672,
      "title": "Cartoon Network",
      "biglogo": "/chbiglogo/1587711584.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1490161905.png",
      "description": "Развлекательный канал для детей от 6 до 12 лет.  В эфире комедийные и приключенческие мультсериалы: «Время приключений», «Суперкрошки», «Удивительный мир Гамбола», «Бен 10», «Вся правда о медведях» и другие.",
      "url": "http://www.cartoonnetwork.ru/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "cartoon-network",
      "xvid": 226,
      "button": "№ кнопки 604",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 702,
      "title": "Gulli Girl",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1535708740.png",
      "description": "Телеканал для девочек от 4 до 14 лет. Добрые феи клуба Винкс научат дружбе и взаимовыручке, русалки острова Мако и герои Дримтопии разовьют фантазию, а Полли Покет покажет, как справляться с неприятностями.",
      "url": "http://www.gulli.fr/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "gulli-girl",
      "xvid": 122,
      "button": "№ кнопки 608",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 3451,
      "title": "Nick Jr.",
      "biglogo": "/chbiglogo/1587706718.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665897.png",
      "description": "Для дошкольного возраста.\r\nВместе с героями шоу «Щенячий патруль», «Вспыш и чудо‑машинки», «Шиммер и Шайн», «Нелла, отважная принцесса» и «Даша‑путешественница» дети в игровой форме учатся основам математики, логики и иностранных языков. У них развивается внимательность и фантазия.",
      "url": "http://www.nickjr.com/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "nick-jr",
      "xvid": 210,
      "button": "№ кнопки 602",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 30,
      "title": "Nickelodeon",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1475045753.png",
      "description": "Телеканал для детей и подростков с мультфильмами, шоу и сериалами. Мистиконы, Игроделы, Губка Боб и другие забавные персонажи научат ребенка взаимовыручке и смекалке, разовьют фантазию и эмоциональный интеллект.",
      "url": "http://www.nickelodeon.ru/",
      "hd": 1,
      "thid": 11,
      "display": 3,
      "alias": "nickelodeon",
      "xvid": 218,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 2383,
      "title": "Nickelodeon HD",
      "biglogo": "/chbiglogo/1587706839.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665903.png",
      "description": "Первый детский канал в HD-качестве, которое делает приключения любимых героев еще ярче. Эфир — это несколько тысяч часов контента: «Даша и друзья: приключения в городе», «Чудище Бансен», «ЭлвиННН!!! И бурундуки», «Опасный Генри», «Грозная семейка» и многое другое.",
      "url": "http://www.nickelodeon.ru/",
      "hd": 1,
      "thid": 11,
      "display": 3,
      "alias": "nickelodeon-hd",
      "xvid": 209,
      "button": "№ кнопки 609",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 10121,
      "title": "NickToons",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1617887311.png",
      "description": "Программы и мультфильмы канала специально подобраны под интересы детей от 6 до 10 лет. В эфире представлены такие хиты, как «Губка Боб Квадратные Штаны», «Черепашки-ниндзя» и «Мой шумный дом», а также популярные шоу для семейного просмотра, включая «Пингвины из Мадагаскара», «Кунг-фу Панда» и многие другие. Ежегодно в эфире доступны более 400 часов мультсериалов, включая до 160 новых эпизодов.",
      "url": "",
      "hd": 1,
      "thid": 11,
      "display": 3,
      "alias": "nicktoons",
      "xvid": 5041,
      "button": "№ кнопки 617",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 752,
      "title": "TiJi",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1482143940.png",
      "description": "Телеканал с мультфильмами  для детей от 3 до 7 лет. Пчелка Майя и заботливые мишки научат дружить и общаться, сериал «Волчонок» поможет развить эмоциональный интеллект, а «Цифрики» — освоить азы математики.",
      "url": "http://www.tiji.fr/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "tiji",
      "xvid": 395,
      "button": "№ кнопки 600",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 4601,
      "title": "Канал Disney",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1542961475.png",
      "description": "Развлекательный канал для зрителей любого возраста. В эфире – анимационные хиты Disney и популярные семейные кинофильмы, современные и классические мультсериалы: «Аладдин», «Русалочка», «Леди Баг и Супер-Кот», «Гравити Фолз» и многие другие. Волшебный мир Disney 365 дней в году!",
      "url": "http://disney.ru/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "kanal-disney",
      "xvid": 65,
      "button": "№ кнопки 24",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 9973,
      "title": "Малыш",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1589289438.png",
      "description": "Телеканал для детей дошкольного возраста. В эфире российские и зарубежные мультсериалы:  «Приключения Мими на Земле», «Любимчики», «Барбарики», «Куми‑Куми», а также познавательные программы:  «Формы и размеры», «Живые карандаши», «Университет для малышей», «Считалочка».",
      "url": "",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "malysh",
      "xvid": 4803,
      "button": "№ кнопки 605",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 3811,
      "title": "Мульт",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886426.png",
      "description": "Телеканал российских мультфильмов для детей до 6 лет. Веселые Кубики расскажут, как устроен космос, Фиксики познакомят ребят с техникой, а общаться и дружить научат Лунтик, Малышарики и Барбоскины.",
      "url": "http://mult.tlum.ru/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "mult",
      "xvid": 193,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 9703,
      "title": "МУЛЬТ HD",
      "biglogo": "/chbiglogo/1587707007.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1575273759.png",
      "description": "Телеканал российских мультфильмов для детей до 6 лет. Веселые Кубики расскажут, как устроен космос, Фиксики познакомят ребят с техникой, а общаться и дружить научат Лунтик, Малышарики и Барбоскины.",
      "url": "http://mult.tlum.ru/",
      "hd": 1,
      "thid": 11,
      "display": 3,
      "alias": "mult-hd",
      "xvid": 2693,
      "button": "№ кнопки 616",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 6513,
      "title": "Мультимузыка",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520930386.png",
      "description": "Телеканал с музыкой из мультфильмов. Бодрые мелодии помогут проснуться, а колыбельные из «Смешариков», «Ми-ми-мишек» и «Фиксиков» — заснуть. Слушайте песни-обучалки и танцуйте под заводные ритмы.",
      "url": "https://signalmedia.ru/#/channel/28",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "multimuzyka",
      "xvid": 2813,
      "button": "№ кнопки 615",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 6483,
      "title": "О!  ",
      "biglogo": "/chbiglogo/1587707120.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520930205.png",
      "description": "По статистике четырехлетний малыш в день задает около 450 вопросов. Этот канал дает на них ответы! Здесь собраны  развивающие передачи и мультфильмы, которые учат читать, считать, рисовать и говорить по-английски. По выходным дням на «О!» идут художественные и анимационные фильмы. Можно смотреть всей семьей.",
      "url": "http://www.kanal-o.ru/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "o",
      "xvid": 2603,
      "button": "№ кнопки 610",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 481,
      "title": "Радость моя",
      "biglogo": "/chbiglogo/1587707183.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502688644.png",
      "description": "Семейный образовательный канал. Знакомит детей с законами математики, физики, биологии, химии. Передачи для семейного просмотра – «Домашний очаг», «Неравнодушный разговор». Особенность канала — блок православных программ: история русской церкви, вопросы духовности, православные праздники.",
      "url": "http://www.radostmoya.ru",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "radost-moya",
      "xvid": 265,
      "button": "№ кнопки 613",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 4161,
      "title": "Рыжий",
      "biglogo": "/chbiglogo/1587707200.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474887066.png",
      "description": "Для детей от 5 до 12 лет. Любимые серии популярных мультфильмов «Лунтик», «Фиксики», «Смешарики», «Маша и медведь», «Алиса знает, что делать», «Летающие звери», «Пузыри» круглосуточно! Добрые советские мультфильмы, фильмы и сериалы для детей постарше. Передачи канала сопровождает язык жестов для детей с ограничением слуха.",
      "url": "http://ryzhiy.tv/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "ryzhiy",
      "xvid": 502,
      "button": "№ кнопки 614",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 3461,
      "title": "СТС Kids HD",
      "biglogo": "/chbiglogo/1617887899.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1617887899.png",
      "description": "Телеканал для детей, которые любят хорошие мультфильмы и для родителей, которые хотят, чтобы их дети обучались развлекаясь. Программа передач разработана с учетом рекомендаций экспертов психологического факультета МГУ им. М.В. Ломоносова. В эфире СТС Kids идут знаменитые мировые франшизы: «Кот в сапогах», «Король Джулиан», «Семейка Крудс», «Драконы. Гонки по краю», «Мистер Пибоди и Шерман», анимационные проекты собственного производства: «Три кота», «Царевны» и другие.",
      "url": "",
      "hd": 1,
      "thid": 11,
      "display": 3,
      "alias": "sts-kids-hd",
      "xvid": 5051,
      "button": "№ кнопки 612",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 2993,
      "title": "Уникум",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1581483401.png",
      "description": "Телеканал с развивающими мультфильмами и передачами. Почемучка расскажет, как устроена вселенная, программа «Шах и мат!» поможет освоить шахматы, а кондитер Сладкоежкина научит печь десерты.",
      "url": "http://telekanaldetskiy.ru/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "unikum",
      "xvid": 4343,
      "button": "№ кнопки 606",
      "bids": 92,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 143,
      "title": "Bridge TV",
      "biglogo": "/chbiglogo/1638784331.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1638784331.jpg",
      "description": "Телеканал о зарубежной поп-музыке. Слушайте современные хиты и ретро-шлягеры, следите за звездами в соцсетях с программой #Repost, танцуйте с детьми под мультяшные клипы в Baby Time.",
      "url": "https://bridgemedia.ru/",
      "hd": 0,
      "thid": 13,
      "display": 3,
      "alias": "bridge-tv",
      "xvid": 54,
      "button": "№ кнопки 658",
      "bids": 92,
      "theme": {
        "thid": 13,
        "name": "Музыкальные",
        "plural": "Музыкальные",
        "alias": "music",
        "weight": 6
      }
    }, {
      "chid": 7593,
      "title": "BRIDGE TV Classic",
      "biglogo": "/chbiglogo/1638784423.jpg",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1638784423.jpg",
      "description": "Телеканал о зарубежной поп-музыке 70-х, 80-х и 90-х годов. Просыпайтесь под энергичные ритмы «Аббы», слушайте подборки золотых хитов, расслабляйтесь вечером под мелодичные композиции.",
      "url": "https://bridgemedia.ru/",
      "hd": 0,
      "thid": 13,
      "display": 3,
      "alias": "bridge-tv-classic",
      "xvid": 2763,
      "button": "№ кнопки 656",
      "bids": 92,
      "theme": {
        "thid": 13,
        "name": "Музыкальные",
        "plural": "Музыкальные",
        "alias": "music",
        "weight": 6
      }
    }, {
      "chid": 742,
      "title": "BRIDGE TV Русский хит",
      "biglogo": "/chbiglogo/1638784531.jpg",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1638784531.jpg",
      "description": "Телеканал о российской поп-музыке. Слушайте ретро-шлягеры и современные хиты, танцуйте с детьми под мультяшные клипы в Baby Time. Узнавайте последние новости шоу-бизнеса в программе «Детали».",
      "url": "https://bridgemedia.ru/",
      "hd": 0,
      "thid": 13,
      "display": 3,
      "alias": "bridge-tv-russkiy-khit",
      "xvid": 337,
      "button": "№ кнопки 654",
      "bids": 92,
      "theme": {
        "thid": 13,
        "name": "Музыкальные",
        "plural": "Музыкальные",
        "alias": "music",
        "weight": 6
      }
    }, {
      "chid": 2493,
      "title": "Europa Plus TV",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474881609.png",
      "description": "Музыкальный телеканал с хитами российской и зарубежной поп-музыки. Слушайте горячие подборки в Hit Non Stop и Dance Chart, смотрите клипы с переводом, знакомьтесь со звездами в программе #MadeInRu.",
      "url": "http://www.europaplustv.com/",
      "hd": 0,
      "thid": 13,
      "display": 3,
      "alias": "europa-plus-tv",
      "xvid": 100,
      "button": "№ кнопки 657",
      "bids": 92,
      "theme": {
        "thid": 13,
        "name": "Музыкальные",
        "plural": "Музыкальные",
        "alias": "music",
        "weight": 6
      }
    }, {
      "chid": 1112,
      "title": "Mezzo Live HD",
      "biglogo": "/chbiglogo/1587709281.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502688990.png",
      "description": "Канал ретранслирует концерты классической музыки, оперы, балетные постановки и джазовые выступления со всего мира. Побывайте в знаменитых концертных залах планеты не выходя из дома.",
      "url": "http://www.mezzo.tv",
      "hd": 1,
      "thid": 13,
      "display": 3,
      "alias": "mezzo-live-hd",
      "xvid": 182,
      "button": "№ кнопки 659",
      "bids": 92,
      "theme": {
        "thid": 13,
        "name": "Музыкальные",
        "plural": "Музыкальные",
        "alias": "music",
        "weight": 6
      }
    }, {
      "chid": 9863,
      "title": "Music Box Russia",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1587534617.png",
      "description": "Российский музыкальный телеканал. В эфире свежие российские и зарубежные клипы, хит-парады и музыкальные блоки. Слушайте хиты с 2000-х до наших дней в режиме нон-стоп.",
      "url": "http://russianmusicbox.tv/",
      "hd": 0,
      "thid": 13,
      "display": 3,
      "alias": "music-box-russia",
      "xvid": 195,
      "button": "№ кнопки 655",
      "bids": 92,
      "theme": {
        "thid": 13,
        "name": "Музыкальные",
        "plural": "Музыкальные",
        "alias": "music",
        "weight": 6
      }
    }, {
      "chid": 257,
      "title": "Ru.TV",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474872053.png",
      "description": "В эфире телеканала вся российская эстрада. Побывайте на концертах любимых исполнителей, не выходя из дома, пойте в караоке. Вспомните хиты 90-х и узнайте последние новости отечественного шоу-бизнеса.",
      "url": "http://ru.tv/?splash=1",
      "hd": 0,
      "thid": 13,
      "display": 3,
      "alias": "rutv",
      "xvid": 334,
      "button": "№ кнопки 650",
      "bids": 92,
      "theme": {
        "thid": 13,
        "name": "Музыкальные",
        "plural": "Музыкальные",
        "alias": "music",
        "weight": 6
      }
    }, {
      "chid": 6423,
      "title": "Ля минор",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520930709.png",
      "description": "Музыкальный телеканал с лирическими песнями. Смотрите и слушайте любимых исполнителей — «Чайф», «Уматурман», Сергея Трофимова, Александра Розенбаума, Любовь Успенскую, Олега Митяева.",
      "url": "https://www.laminortv.ru/",
      "hd": 0,
      "thid": 13,
      "display": 3,
      "alias": "lya-minor",
      "xvid": 561,
      "button": "№ кнопки 652",
      "bids": 92,
      "theme": {
        "thid": 13,
        "name": "Музыкальные",
        "plural": "Музыкальные",
        "alias": "music",
        "weight": 6
      }
    }, {
      "chid": 6473,
      "title": "О2",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520930614.png",
      "description": "Музыкально-развлекательный канал. Смотрите живые концерты и записи выступлений звезд. Узнайте, как найти работу мечты, с программой «Кому жить хорошо», познакомьтесь с питомцами кумиров с «Грум и молния».",
      "url": "http://o2tv.ru/",
      "hd": 0,
      "thid": 13,
      "display": 3,
      "alias": "o2",
      "xvid": 2743,
      "button": "№ кнопки 651",
      "bids": 92,
      "theme": {
        "thid": 13,
        "name": "Музыкальные",
        "plural": "Музыкальные",
        "alias": "music",
        "weight": 6
      }
    }, {
      "chid": 141,
      "title": "ТНТ MUSIC",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1484216835.png",
      "description": "В эфире телеканала более 10 000 клипов от современных исполнителей, новости музыки, кино и моды. Смотрите подборки хитов разных стран в «Музыке континентов», учитесь читать рэп с «Техникой речи».",
      "url": "https://tntmusic.ru/",
      "hd": 0,
      "thid": 13,
      "display": 3,
      "alias": "tnt-music",
      "xvid": 1951,
      "button": "№ кнопки 653",
      "bids": 92,
      "theme": {
        "thid": 13,
        "name": "Музыкальные",
        "plural": "Музыкальные",
        "alias": "music",
        "weight": 6
      }
    }, {
      "chid": 6683,
      "title": "CNN",
      "biglogo": "/chbiglogo/1587707527.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1521093078.png",
      "description": "Информационно-аналитический канал, передает новости со всего мира. В эфире политические, культурные, спортивные, финансовые, а также аналитические и документальные программы, обзоры международного бизнеса.",
      "url": "https://edition.cnn.com/",
      "hd": 0,
      "thid": 12,
      "display": 3,
      "alias": "cnn",
      "xvid": 2943,
      "button": "№ кнопки 705",
      "bids": 92,
      "theme": {
        "thid": 12,
        "name": "Новостные",
        "plural": "Новостные",
        "alias": "news",
        "weight": 7
      }
    }, {
      "chid": 47,
      "title": "Deutsche Welle",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474870996.png",
      "description": "В эфире новости со всего мира на немецком и английском языках — свежие выпуски  каждый час. Также смотрите программы об искусстве и науке, природе и путешествиях, здоровье и спорте.",
      "url": "http://www.dw.com/ru/%D1%82%D0%B5%D0%BC%D1%8B-%D0%B4%D0%BD%D1%8F/s-9119",
      "hd": 0,
      "thid": 12,
      "display": 3,
      "alias": "deutsche-welle",
      "xvid": 91,
      "button": "№ кнопки 703",
      "bids": 92,
      "theme": {
        "thid": 12,
        "name": "Новостные",
        "plural": "Новостные",
        "alias": "news",
        "weight": 7
      }
    }, {
      "chid": 236,
      "title": "France 24",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871998.png",
      "description": "В эфире канала новости на французском и английском языках — свежие выпуски каждые полчаса. Смотрите обзоры французской прессы, мировых событий спорта, моды и бизнеса, программы об искусстве и науке.",
      "url": "http://www.france24.com/en/",
      "hd": 0,
      "thid": 12,
      "display": 3,
      "alias": "france-24",
      "xvid": 111,
      "button": "№ кнопки 702",
      "bids": 92,
      "theme": {
        "thid": 12,
        "name": "Новостные",
        "plural": "Новостные",
        "alias": "news",
        "weight": 7
      }
    }, {
      "chid": 3013,
      "title": "Russia Today",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474883985.png",
      "description": "Новостной телеканал на английском языке. Смотрите политические шоу с легендарными журналистами, острые интервью, документальные фильмы об эпохальных событиях — в формате высокой четкости.",
      "url": "https://russian.rt.com/",
      "hd": 0,
      "thid": 12,
      "display": 3,
      "alias": "russia-today",
      "xvid": 339,
      "button": "№ кнопки 704",
      "bids": 92,
      "theme": {
        "thid": 12,
        "name": "Новостные",
        "plural": "Новостные",
        "alias": "news",
        "weight": 7
      }
    }, {
      "chid": 3561,
      "title": "Евроновости",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1507898607.png",
      "description": "Телеканал транслирует новости со всего мира. В эфире обзоры без политики и комментариев: общество, экономика, спорт, наука, рынок, биржевые сводки и погода.",
      "url": "http://lifenews.ru/",
      "hd": 0,
      "thid": 12,
      "display": 3,
      "alias": "evronovosti",
      "xvid": 3163,
      "button": "№ кнопки 700",
      "bids": 92,
      "theme": {
        "thid": 12,
        "name": "Новостные",
        "plural": "Новостные",
        "alias": "news",
        "weight": 7
      }
    }, {
      "chid": 6663,
      "title": "Известия HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520920753.jpg",
      "description": "Телеканал с новостями политики, экономики и культуры — свежие выпуски каждые 15 минут. Следите за курсами валют и прогнозом погоды, узнайте, что произошло в этот день много лет назад.",
      "url": "http://wbc.com.ru/",
      "hd": 1,
      "thid": 12,
      "display": 3,
      "alias": "izvestiya-hd",
      "xvid": 2523,
      "button": "№ кнопки 708",
      "bids": 92,
      "theme": {
        "thid": 12,
        "name": "Новостные",
        "plural": "Новостные",
        "alias": "news",
        "weight": 7
      }
    }, {
      "chid": 4181,
      "title": "МИР 24",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502688827.png",
      "description": "Телеканал о жизни в странах СНГ. Следите за культурной, экономической, спортивной жизнью Евразии, смотрите репортажи со «Славянского базара в Витебске», программы о путешествиях и выпуски мировых новостей.",
      "url": "http://mir24.tv/",
      "hd": 0,
      "thid": 12,
      "display": 3,
      "alias": "mir-24",
      "xvid": 185,
      "button": "№ кнопки 706",
      "bids": 92,
      "theme": {
        "thid": 12,
        "name": "Новостные",
        "plural": "Новостные",
        "alias": "news",
        "weight": 7
      }
    }, {
      "chid": 32,
      "title": "РБК ТВ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474870945.png",
      "description": "В эфире телеканала обзор российских и зарубежных событий бизнеса, экономики и политики. Узнавайте свежие новости каждые полчаса, будьте в курсе, во что инвестировать сбережения и как меняется рынок труда.",
      "url": "http://tv.rbc.ru/",
      "hd": 0,
      "thid": 12,
      "display": 3,
      "alias": "rbk-tv",
      "xvid": 268,
      "button": null,
      "bids": 92,
      "theme": {
        "thid": 12,
        "name": "Новостные",
        "plural": "Новостные",
        "alias": "news",
        "weight": 7
      }
    }, {
      "chid": 3133,
      "title": "Arirang",
      "biglogo": "/chbiglogo/1609152292.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1609152292.png",
      "description": "Канал о Южной Корее. Корейская политика, экономика, спорт, мода, кухня, шоу-бизнес и другие сферы жизни страны. Вещание идет на английском языке.",
      "url": "http://www.arirang.co.kr/index.asp",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "arirang",
      "xvid": 42,
      "button": "№ кнопки 757",
      "bids": 92,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 6291,
      "title": "Kazakh TV",
      "biglogo": "/chbiglogo/1587707570.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1496672023.png",
      "description": "Национальный канал республики Казахстан. В эфире канала — главные казахстанские и мировые новости, фильмы, развлекательные программы и многое другое.",
      "url": "http://kazakh-tv.kz",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "kazakh-tv",
      "xvid": 149,
      "button": "№ кнопки 757",
      "bids": 92,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 3113,
      "title": "NHK World",
      "biglogo": "/chbiglogo/1587707648.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474884077.png",
      "description": "Для тех, кто интересуется Японией, ее экономикой, историей, культурой, внешней и внутренней политикой. Вещание идет на английском языке.",
      "url": "http://www3.nhk.or.jp/nhkworld/",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "nhk-world",
      "xvid": 208,
      "button": "№ кнопки 752",
      "bids": 92,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 1292,
      "title": "Беларусь 24",
      "biglogo": "/chbiglogo/1587707703.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474874066.png",
      "description": "Все о событиях в Беларуси, точно и своевременно. Вещание на белорусском и русском языках.",
      "url": "http://belarus24.by/",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "belarus-24",
      "xvid": 50,
      "button": "№ кнопки 758",
      "bids": 92,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 265,
      "title": "БСТ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474872067.png",
      "description": "Информационно-развлекательный телеканал Башкирии на башкирском языке. Встречайте утро с «Салям», путешествуйте по республике с «Моя планета Башкортостан», узнавайте главные новости региона.",
      "url": "http://tv-rb.ru/",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "bst",
      "xvid": 56,
      "button": "№ кнопки 759",
      "bids": 92,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 3143,
      "title": "Грозный",
      "biglogo": "/chbiglogo/1587707740.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474885201.png",
      "description": "Региональный канал Чеченской Республики для чеченцев, живущих в разных регионах России, и для зрителей, которые интересуются жизнью Чечни. В эфире познавательные, детские, развлекательные, музыкальные, публицистические и посвященные исламу программы.",
      "url": "http://groztrk.net/",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "groznyy",
      "xvid": 119,
      "button": "№ кнопки 754",
      "bids": 92,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 3093,
      "title": "Майдан",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474884054.png",
      "description": "Татарский музыкально-развлекательный телеканал. Смотрите концерты звезд Татарстана, программы о культурных и спортивных событиях республики. Передайте музыкальный привет близким в прямом эфире с Гузель Уразовой.",
      "url": "http://maidantv.com/",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "maydan",
      "xvid": 180,
      "button": "№ кнопки 751",
      "bids": 92,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 40,
      "title": "ТНВ",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474870976.png",
      "description": "Телеканал Татарстана на татарском и русском языках. Узнавайте новости республики, смотрите концерты, ток-шоу, познавательные программы, а также фильмы и сериалы на двух языках.",
      "url": "http://tnv.ru/",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "tnv",
      "xvid": 421,
      "button": "№ кнопки 753",
      "bids": 92,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 2563,
      "title": "ТНВ Планета",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474881688.png",
      "description": "Телеканал Татарстана на татарском и русском языках. В эфире новости республики, концерты, ток-шоу, познавательные передачи. Программы повторяются с учетом часовых поясов России — смотрите в удобное время.",
      "url": "http://www.tnv.ru/",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "tnv-planeta",
      "xvid": 422,
      "button": "№ кнопки 755",
      "bids": 92,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 73,
      "title": "Союз",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474871117.png",
      "description": "Православный телеканал без политики. Смотрите трансляции богослужений, беседы со служителями церкви в прямом эфире, программы о русской истории и культуре. Ежедневно — песнопения и молитвы.",
      "url": "http://tv-soyuz.ru/",
      "hd": 0,
      "thid": 52,
      "display": 3,
      "alias": "soyuz",
      "xvid": 351,
      "button": "№ кнопки 740",
      "bids": 92,
      "theme": {
        "thid": 52,
        "name": "Религиозные",
        "plural": "Религиозные",
        "alias": "religia",
        "weight": 9
      }
    }, {
      "chid": 10431,
      "title": "Classic Music",
      "biglogo": "/chbiglogo/1638270092.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1638270092.png",
      "description": "Первый российский музыкальный канал, посвященный классической музыке, опере и балету, но с современным взглядом на классику, который сотрудничает с ведущими театрами и концертными залами страны и за рубежом. Короткие познавательные программы наполняют каждую минуту интересным контентом.",
      "url": "",
      "hd": 1,
      "thid": 61,
      "display": 3,
      "alias": "classic-music",
      "xvid": 5231,
      "button": "№ кнопки 33",
      "bids": 92,
      "theme": {
        "thid": 61,
        "name": "Канал подарков",
        "plural": "Канал подарков",
        "alias": "podarki",
        "weight": 10
      }
    }],
    "channelsCount": 194,
    "channelsCountHd": 70,
    "children": [],
    "color": "",
    "cost": 0,
    "costRa": [],
    "description": "Пакет цифровых телеканалов различной тематики: новости, спорт, кино, музыка, развлечения, телеканалы для детей, включающий набор каналов в формате высокой четкости (HD) для киноманов, горячих спортивных болельщиков и ценителей современной и классической музыки, а также набор каналов для детей от 2 до 16 лет.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/3cb8ff69a7d00ac7543bb54073976095.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/e930fe813295ecb18f0492efff7a474c.png",
    "logoNoBackground": "",
    "name": "Премиальный",
    "nextRa": [],
    "packetType": 0,
    "state": {
      "actDateTo": null,
      "dateFrom": 1615248000,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": null,
      "unsetState": 1,
      "unsetFrom": null
    },
    "weight": -1
  }],
  "connectedOutTariff": [],
  "canConnect": [{
    "id": 71,
    "active": 0,
    "alias": "/domru-tv/packages/gamer",
    "available": 1,
    "baseCost": 99,
    "channels": [{
      "chid": 5871,
      "title": "E TV",
      "biglogo": "/chbiglogo/1587715401.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1554114081.png",
      "description": "Единственный телеканал об игровой индустрии и киберспорте в России и странах СНГ. Последние новости о видеоиграх, киберспорте, событиях в индустрии. Прямые трансляции киберспортивных турниров.",
      "url": "https://gameshow.ru/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "e-tv",
      "xvid": 2051,
      "button": "№ кнопки 303",
      "bids": 71,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }],
    "channelsCount": 1,
    "channelsCountHd": 1,
    "children": [],
    "color": "linear-gradient(67.21deg, #7AC9DB 13.2%, #5BBCD4 65.86%, #4EB1C8 100.37%)",
    "cost": 99,
    "costRa": [{
      "cost": 69,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1117771
    }, {
      "cost": 49,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1117773
    }],
    "description": "Пакет для тех, кто увлекается компьютерными играми и киберспортом.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/18490786af470327df4030041851e89a.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/50a49def93c7ca3c339089ea8b9b0891.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15734529982342_logo_no_background.png",
    "name": "Геймер",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 14
  }, {
    "id": 72,
    "active": 0,
    "alias": "/domru-tv/packages/russkoe-kino",
    "available": 1,
    "baseCost": 149,
    "channels": [{
      "chid": 5991,
      "title": "Дом кино Premium HD",
      "biglogo": "/chbiglogo/1598601229.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487046478.png",
      "description": "Российские блокбастеры, фильмы, которые еще не вышли в прокат, ретропоказы, кинорелизы года, сериалы и эксклюзивные интервью со звёздами.",
      "url": "http://www.domkino-premium.tv/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "dom-kino-premium-hd",
      "xvid": 2111,
      "button": "№ кнопки 233",
      "bids": 72,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 5981,
      "title": "РОДНОЕ КИНО",
      "biglogo": "/chbiglogo/1587712262.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1491976714.png",
      "description": "В эфире канала культовые советские фильмы, лидеры российского кинопроката разных лет, фильмы-обладатели премий в России и за рубежом.",
      "url": "http://www.nastroykino.ru/rodnoe-kino/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "rodnoe-kino",
      "xvid": 227,
      "button": "№ кнопки 232",
      "bids": 72,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6433,
      "title": "Русский бестселлер",
      "biglogo": "/chbiglogo/1587712346.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1604057383.png",
      "description": "Золотой фонд сериалов России. Экранизации великих литературных произведений, детективы, приключения, лирические мелодрамы и исторические драмы.",
      "url": "http://www.bestrussia.tv",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "russkiy-bestseller",
      "xvid": 335,
      "button": "№ кнопки 201",
      "bids": 72,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6443,
      "title": "Русский детектив",
      "biglogo": "/chbiglogo/1587712364.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520928131.png",
      "description": "Канал российских детективных фильмов и сериалов. Запутанные сюжеты, неожиданные развязки, загадки и тайны.",
      "url": "http://rudetective.tv/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "russkiy-detektiv",
      "xvid": 1851,
      "button": null,
      "bids": 72,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }],
    "channelsCount": 4,
    "channelsCountHd": 1,
    "children": [],
    "color": "linear-gradient(80.31deg, #F0DCB5 -10.59%, #EBBF7D 17.56%, #C58D46 89.95%)",
    "cost": 149,
    "costRa": [{
      "cost": 119,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1118788
    }, {
      "cost": 99,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1118790
    }],
    "description": "Пакет для тех, кто любит русское кино. Смотрите классику советского кино, громкие премьеры и интересные детективы.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/a54f8243a0721a822e63c504599082b8.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/1836fdf0a5206d5bfc824a81f209c3e1.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15731922633762_logo_no_background.png",
    "name": "Русское кино",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 7
  }, {
    "id": 8,
    "active": 0,
    "alias": "/domru-tv/packages/khl_hd",
    "available": 1,
    "baseCost": 149,
    "channels": [{
      "chid": 3083,
      "title": "KHL Prime",
      "biglogo": "/chbiglogo/1630557497.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1630557497.png",
      "description": "Оригинальный контент и ежедневные хоккейные трансляции в HD-формате.Топ-матчи между лучшими клубами Лиги, предматчевые и послематчевые студии LIVE, мнения экспертов, нарезки лучших голов, сэйвов, силовых приёмов и многое другое.",
      "url": "http://www.khl.ru/",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "khl-prime",
      "xvid": 150,
      "button": "№ кнопки 512",
      "bids": 8,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }],
    "channelsCount": 1,
    "channelsCountHd": 1,
    "children": [],
    "color": "linear-gradient(103.45deg, #79C2F6 1.77%, #54B6FC 103.14%)",
    "cost": 149,
    "costRa": [{
      "cost": 119,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115870
    }, {
      "cost": 99,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115894
    }],
    "description": "Шайбу! Смотрите прямые трансляции с матчей Молодежной хоккейной лиги, Континентальной хоккейной лиги, Высшей хоккейной лиги.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/33aa82e8958ff12dcc1d8374cbe26b04.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/2b4807efc631a19a56bb17918b569f2e.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15730139794475_logo_no_background.png",
    "name": "КХЛ HD",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 12
  }, {
    "id": 30,
    "active": 0,
    "alias": "/domru-tv/packages/amedia-premium",
    "available": 1,
    "baseCost": 199,
    "channels": [{
      "chid": 7953,
      "title": "Amedia HIT HD",
      "biglogo": "/chbiglogo/1587705951.jpg",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561449337.jpg",
      "description": "Любимые сериалы каждый день в одно и то же время: «Клан Сопрано», «Калифорникейшн», «Декстер», «Борджиа», «Викинги» и другие.\r\nМарафоны сериалов для «запойного» просмотра по выходным. Художественные фильмы каждый день в полночь.",
      "url": "http://amediahit.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "amedia-hit-hd",
      "xvid": 1341,
      "button": "№ кнопки 229",
      "bids": 30,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 3391,
      "title": "Amedia Premium HD",
      "biglogo": "/chbiglogo/1587706167.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665392.png",
      "description": "Премьеры сериалов одновременно с миром: «Игра престолов», «Мир Дикого Запада», «Американская история ужасов», «Викинги», «Твин Пикс», «Шерлок» и другие. Коллекция документальных фильмов, концертов и стендап-шоу. Музыкальные фестивали и церемонии в прямом эфире.",
      "url": "http://amedia.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "amedia-premium-hd",
      "xvid": 40,
      "button": "№ кнопки 221",
      "bids": 30,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }],
    "channelsCount": 2,
    "channelsCountHd": 2,
    "children": [],
    "color": "#9FD6F5",
    "cost": 199,
    "costRa": [{
      "cost": 169,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115868
    }, {
      "cost": 149,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115892
    }],
    "description": "Смотрите золотую библиотеку HBO на Amedia Hit — «Мир Дикого Запада», «Игра престолов» и другое. А «Викингов» на Amedia Premium HD.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/52e220cf41a77c31266febd0c98f67a9.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/b8cd61201f32505cf5f45abc76ee805c.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15730136876722_logo_no_background.png",
    "name": "Amedia Premium HD",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 0
  }, {
    "id": 70,
    "active": 0,
    "alias": "/domru-tv/packages/tv_man",
    "available": 1,
    "baseCost": 199,
    "channels": [{
      "chid": 6493,
      "title": "Дикая охота HD",
      "biglogo": "/chbiglogo/1587712386.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520928924.png",
      "description": "Для начинающих и опытных охотников. Рассказы об охоте, тестирование снаряжения и оружия, охотничья кулинария, подводная охота, фотоохота, новинки охотничьего снаряжения, приключения и путешествия в разные уголки земного шара.",
      "url": "http://dikoe.tv/channels/dikaya-okhota-hd.html",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "dikaya-okhota-hd",
      "xvid": 2633,
      "button": "№ кнопки 438",
      "bids": 70,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6503,
      "title": "Дикая рыбалка HD",
      "biglogo": "/chbiglogo/1587712410.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520928940.png",
      "description": "Мастер-классы рыболовов-экспертов, рассказы о рыбной ловле, тестирование снастей, рыболовная кулинария, летняя и зимняя рыбалка, новинки в мире рыболовного снаряжения, приключения человека в дикой природе.",
      "url": "http://dikoe.tv/channels/dikaya-rybalka-hd.html",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "dikaya-rybalka-hd",
      "xvid": 2623,
      "button": "№ кнопки 431",
      "bids": 70,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 5891,
      "title": "Оружие",
      "biglogo": "/chbiglogo/1587712300.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502689055.png",
      "description": "Первый в России телеканал об оружии. Все виды оружия и его история, оружие как часть мировой культуры, армии мира и боевые техники. Около 1000 часов документальных программ и фильмов, снятых в России и за рубежом.",
      "url": "http://www.oruzhie.tv/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "oruzhie",
      "xvid": 631,
      "button": "№ кнопки 429",
      "bids": 70,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 5911,
      "title": "Бокс ТВ",
      "biglogo": "/chbiglogo/1587710731.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1479383275.png",
      "description": "Трансляция 90% мировых топ-боксерских поединков. Интервью спортсменов и тренеров, эксклюзивные бои, свежие новости и события профессионального бокса.",
      "url": "http://boxingtv.ru/",
      "hd": 0,
      "thid": 10,
      "display": 3,
      "alias": "boks-tv",
      "xvid": 1521,
      "button": "№ кнопки 514",
      "bids": 70,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 5901,
      "title": "Драйв",
      "biglogo": "/chbiglogo/1587710695.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1479383090.png",
      "description": "Канал об автомобилях, мотоциклах и путешествиях. Тест-драйвы, репортажи с выставок и автосалонов, история гигантов автопрома, автоспорт, автотуризм, безопасность на дороге, уроки вождения и многое другое.",
      "url": "http://drive-tv.ru/",
      "hd": 0,
      "thid": 10,
      "display": 3,
      "alias": "drayv",
      "xvid": 1741,
      "button": "№ кнопки 520",
      "bids": 70,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 5921,
      "title": "Моторспорт ТВ",
      "biglogo": "/chbiglogo/1587714653.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1538404506.png",
      "description": "15 лет канал делает трансляции и обзоры известных авто и мото чемпионатов. В эфире документальные фильмы, интервью со звездами спорта, передачи о самых быстрых и самых дорогих машинах в мире и еще много интересного.",
      "url": "https://www.motorstv.com/",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "motorsport-tv",
      "xvid": 3073,
      "button": "№ кнопки 507",
      "bids": 70,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }],
    "channelsCount": 6,
    "channelsCountHd": 3,
    "children": [],
    "color": "linear-gradient(277.25deg, #000000 -16.85%, rgba(0, 0, 0, 0.54) 76.8%)",
    "cost": 199,
    "costRa": [{
      "cost": 169,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1117775
    }, {
      "cost": 149,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1117777
    }],
    "description": "Трансляции бокса и гоночных серий, программы об оружии и военной технике, спортивные новости.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/16e4d3975bebaef855f6aa311d84d1cd.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/59f330524cdd83cd9413e1ed96dbfa14.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15730140986024_logo_no_background.png",
    "name": "Настоящий мужской",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 13
  }, {
    "id": 73,
    "active": 0,
    "alias": "/domru-tv/packages/udivitelnaya-planeta",
    "available": 1,
    "baseCost": 199,
    "channels": [{
      "chid": 6131,
      "title": "DocuBox HD",
      "biglogo": "/chbiglogo/1587711825.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487049915.png",
      "description": "Документальный канал, который показывает фильмы, сериалы и программы о дикой природе, науке, человечестве и мировой культуре.",
      "url": "",
      "hd": 1,
      "thid": 7,
      "display": 1,
      "alias": "docubox-hd",
      "xvid": 2261,
      "button": "№ кнопки 434",
      "bids": 73,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6161,
      "title": "Galaxy",
      "biglogo": "/chbiglogo/1587711860.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487050566.png",
      "description": "Первый российский научно-фантастический канал о космосе и авиации, развитии воздухоплавания и астронавтики, исследованиях земной атмосферы и космического пространства.",
      "url": "http://galaxy-tv.ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "galaxy",
      "xvid": 1941,
      "button": "№ кнопки 437",
      "bids": 73,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 7563,
      "title": "HD Life",
      "biglogo": "/chbiglogo/1587715506.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561113125.png",
      "description": "Телеканал о физических и интеллектуальных возможностях человека, окружающем мире, природе и Вселенной. Программы поделены по темам: «Человек», «Земля», «Вселенная». У каждой темы свой цвет. Смотрите, что нравится: красный – программы о Человеке и его возможностях, фиолетовый – о тайнах Вселенной, зеленый – о Земле и многообразии жизни.",
      "url": "https://www.hdlife.ru/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "hd-life",
      "xvid": 123,
      "button": "№ кнопки 420",
      "bids": 73,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6141,
      "title": "Museum HD",
      "biglogo": "/chbiglogo/1587715422.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1554790787.png",
      "description": "Канал об изобразительном искусстве. Узнайте о последних мировых выставках, окунитесь в историю музеев и экспонатов, познакомьтесь с современными видами искусства, следите за аукционами и смотрите, как создаются шедевры архитектуры.",
      "url": "http://www.themuseumchannel.tv/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "museum-hd",
      "xvid": 1621,
      "button": "№ кнопки 435",
      "bids": 73,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6111,
      "title": "RTG HD",
      "biglogo": "/chbiglogo/1587711809.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487049630.png",
      "description": "Познавательный канал о России: природа, животный мир, активный отдых, охота и рыбалка, круизы и экскурсии, прогулки по городам, люди, культура, религия, история, кухня, наука и техника, курорты.",
      "url": "http://rtgtv.ru/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "rtg-hd",
      "xvid": 2191,
      "button": "№ кнопки 432",
      "bids": 73,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6493,
      "title": "Дикая охота HD",
      "biglogo": "/chbiglogo/1587712386.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520928924.png",
      "description": "Для начинающих и опытных охотников. Рассказы об охоте, тестирование снаряжения и оружия, охотничья кулинария, подводная охота, фотоохота, новинки охотничьего снаряжения, приключения и путешествия в разные уголки земного шара.",
      "url": "http://dikoe.tv/channels/dikaya-okhota-hd.html",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "dikaya-okhota-hd",
      "xvid": 2633,
      "button": "№ кнопки 438",
      "bids": 73,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6583,
      "title": "Живая Планета",
      "biglogo": "/chbiglogo/1587714518.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520929836.png",
      "description": "Канал о природе России. Исследования дикой природы, экспедиции, редкие животные, реалити о волонтерских центрах и работе ветеринарных врачей, обучающие программы для детей и родителей, шоу о том, как выбрать питомца.",
      "url": "http://www.live-planet.tv",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "zhivaya-planeta",
      "xvid": 2573,
      "button": "№ кнопки 426",
      "bids": 73,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 9683,
      "title": "Моя Планета HD",
      "biglogo": "/chbiglogo/1587715596.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1575272890.png",
      "description": "Путешествуйте, изучайте и открывайте: что продают на рынках в Македонии и Астрахани, как устроено зрение и супермозг, кого называют шпионами в дикой природе. Приключения и исследования в режиме нон-стоп.",
      "url": "https://www.moya-planeta.ru/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "moya-planeta-hd",
      "xvid": 4153,
      "button": "№ кнопки 436",
      "bids": 73,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6673,
      "title": "Первый вегетарианский",
      "biglogo": "/chbiglogo/1587714623.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1521092672.png",
      "description": "Уникальный познавательно-развлекательный телеканал, посвященный теме вегетарианства и ведения здорового образа жизни. Телеканал будет интересен вегетарианцам, веганам, сыроедам и всем, кто интересуется здоровым питанием и здоровым образом жизни.",
      "url": "https://www.1veg-tv.ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "pervyy-vegetarianskiy",
      "xvid": 2593,
      "button": "№ кнопки 428",
      "bids": 73,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6573,
      "title": "Поехали!",
      "biglogo": "/chbiglogo/1587714553.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520929932.png",
      "description": "Телеканал о ярких и незабываемых приключениях по России и ближнему зарубежью. \r\nКанал для тех, кто хочет путешествовать по России, узнать о своей стране, природе разных регионов, памятниках истории и культуры, людях. В программах канала — свежая точка зрения на внутренний туризм, информация о маршрутах, экскурсиях и ценах.",
      "url": "http://www.poehali.tv/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "poekhali",
      "xvid": 2613,
      "button": "№ кнопки 433",
      "bids": 73,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }],
    "channelsCount": 10,
    "channelsCountHd": 6,
    "children": [],
    "color": "linear-gradient(92.06deg, #90D4A3 -49.29%, #78CE90 30.72%, #66B878 87.63%)",
    "cost": 199,
    "costRa": [{
      "cost": 149,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1118784
    }, {
      "cost": 99,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1118786
    }],
    "description": "Каналы про научные открытия, изобретения и космос, путешествия по России и миру, знакомство с культурами.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/f0d7adf48cb122c426c04407ab45d0e7.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/82ffa486c5906d94ba3dbc262f1d2d57.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15730140529806_logo_no_background.png",
    "name": "Удивительная планета",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 8
  }, {
    "id": 22,
    "active": 0,
    "alias": "/domru-tv/packages/kino_i_music_hd",
    "available": 1,
    "baseCost": 200,
    "channels": [{
      "chid": 3411,
      "title": "A1",
      "biglogo": "/chbiglogo/1587555204.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1478599976.png",
      "description": "Телеканал для мужчин. Рейтинговые мужские сериалы: «Рэй Донован», «Черные паруса», «Банши», «Миллиарды», «Настоящий детектив».\r\nПодборка фильмов популярных жанров — от экшн-блокбастеров до черных комедий.  Документальные программы — независимые журналистские расследования, биографии и интервью.",
      "url": "http://amedia.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "a1",
      "xvid": 38,
      "button": "№ кнопки 220",
      "bids": 22,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 9883,
      "title": "FAN HD",
      "biglogo": "/chbiglogo/1592801687.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1589287244.png",
      "description": "Телеканал анимационного, игрового кино и сериалов в жанре фэнтези — от классических проектов до новинок кинофантастики. Смотрите культовые аниме‑фильмы и сериалы японских киностудий, а также кино и сериалы Китая, Южной Кореи, США и др.",
      "url": "https://fantv.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "fan-hd",
      "xvid": 4743,
      "button": "№ кнопки 250",
      "bids": 22,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 2763,
      "title": "Hollywood HD",
      "biglogo": "/chbiglogo/1587709031.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665696.png",
      "description": "Художественные и анимационные фильмы разных лет и жанров киностудии MGM и других голливудских студий.",
      "url": "",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "hollywood-hd",
      "xvid": 3383,
      "button": "№ кнопки 223",
      "bids": 22,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 7533,
      "title": "Paramount Channel HD",
      "biglogo": "/chbiglogo/1587709073.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561112339.png",
      "description": "Киноканал с  фильмами от Paramount Pictures — одной из старейших американских киностудий. В эфире фильмы  разных жанров и эпох — от комедий до мистики, от лент 60-х годов до современных. На канале можно посмотреть фильмы, которые еще не показывали в России.",
      "url": "https://www.paramountchannel.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "paramount-channel-hd",
      "xvid": 2933,
      "button": "№ кнопки 245",
      "bids": 22,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6453,
      "title": "Комедия",
      "biglogo": "/chbiglogo/1587709130.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520929574.png",
      "description": "Канал отечественных и зарубежных комедий. Классика жанра и новинки последних лет.",
      "url": "http://komedia-tv.ru/",
      "hd": 0,
      "thid": 6,
      "display": 3,
      "alias": "komediya",
      "xvid": 2773,
      "button": "№ кнопки 240",
      "bids": 22,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 2773,
      "title": "myZen.tv HD",
      "biglogo": "/chbiglogo/1587709272.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474881834.png",
      "description": "Йога, медитация, массаж, релаксация, спа, фитнес, путешествия, семейные поездки, съемки самых красивых уголков планеты. Экономьте время на походах в спортзал, выполняя упражнения из различных практик вместе с профессиональными тренерами myZen.tv.",
      "url": "http://www.myzen.tv/",
      "hd": 1,
      "thid": 2,
      "display": 3,
      "alias": "myzentv-hd",
      "xvid": 198,
      "button": "№ кнопки 304",
      "bids": 22,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 1112,
      "title": "Mezzo Live HD",
      "biglogo": "/chbiglogo/1587709281.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502688990.png",
      "description": "Канал ретранслирует концерты классической музыки, оперы, балетные постановки и джазовые выступления со всего мира. Побывайте в знаменитых концертных залах планеты не выходя из дома.",
      "url": "http://www.mezzo.tv",
      "hd": 1,
      "thid": 13,
      "display": 3,
      "alias": "mezzo-live-hd",
      "xvid": 182,
      "button": "№ кнопки 659",
      "bids": 22,
      "theme": {
        "thid": 13,
        "name": "Музыкальные",
        "plural": "Музыкальные",
        "alias": "music",
        "weight": 6
      }
    }],
    "channelsCount": 7,
    "channelsCountHd": 6,
    "children": [],
    "color": "linear-gradient(285.38deg, rgba(42, 162, 231, 0.8) 2.45%, rgba(73, 121, 205, 0.917271) 37.51%, #8D1F95 114.92%)",
    "cost": 200,
    "costRa": [{
      "cost": 170,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115864
    }, {
      "cost": 150,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115888
    }],
    "description": "<p>Занимайтесь йогой с каналом myZen.tv, смотрите концерты классической музыки&nbsp;и балет&nbsp;на Mezzo Live HD, сериалы и фильмы на A1 и Hollywood HD.  </p><p><br></p>",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/372a2b3053f1a429777d310265d633ce.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/012a935cda0e77e0bb95f25dfc162d1d.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15730135259088_logo_no_background.png",
    "name": "Кино и музыка HD",
    "nextRa": [],
    "packetType": 1,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 20
  }, {
    "id": 7,
    "active": 0,
    "alias": "/domru-tv/packages/nacionalnii",
    "available": 1,
    "baseCost": 200,
    "channels": [{
      "chid": 6683,
      "title": "CNN",
      "biglogo": "/chbiglogo/1587707527.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1521093078.png",
      "description": "Информационно-аналитический канал, передает новости со всего мира. В эфире политические, культурные, спортивные, финансовые, а также аналитические и документальные программы, обзоры международного бизнеса.",
      "url": "https://edition.cnn.com/",
      "hd": 0,
      "thid": 12,
      "display": 3,
      "alias": "cnn",
      "xvid": 2943,
      "button": "№ кнопки 705",
      "bids": 7,
      "theme": {
        "thid": 12,
        "name": "Новостные",
        "plural": "Новостные",
        "alias": "news",
        "weight": 7
      }
    }, {
      "chid": 3133,
      "title": "Arirang",
      "biglogo": "/chbiglogo/1609152292.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1609152292.png",
      "description": "Канал о Южной Корее. Корейская политика, экономика, спорт, мода, кухня, шоу-бизнес и другие сферы жизни страны. Вещание идет на английском языке.",
      "url": "http://www.arirang.co.kr/index.asp",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "arirang",
      "xvid": 42,
      "button": "№ кнопки 757",
      "bids": 7,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 6291,
      "title": "Kazakh TV",
      "biglogo": "/chbiglogo/1587707570.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1496672023.png",
      "description": "Национальный канал республики Казахстан. В эфире канала — главные казахстанские и мировые новости, фильмы, развлекательные программы и многое другое.",
      "url": "http://kazakh-tv.kz",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "kazakh-tv",
      "xvid": 149,
      "button": "№ кнопки 757",
      "bids": 7,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 3113,
      "title": "NHK World",
      "biglogo": "/chbiglogo/1587707648.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474884077.png",
      "description": "Для тех, кто интересуется Японией, ее экономикой, историей, культурой, внешней и внутренней политикой. Вещание идет на английском языке.",
      "url": "http://www3.nhk.or.jp/nhkworld/",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "nhk-world",
      "xvid": 208,
      "button": "№ кнопки 752",
      "bids": 7,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 1292,
      "title": "Беларусь 24",
      "biglogo": "/chbiglogo/1587707703.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474874066.png",
      "description": "Все о событиях в Беларуси, точно и своевременно. Вещание на белорусском и русском языках.",
      "url": "http://belarus24.by/",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "belarus-24",
      "xvid": 50,
      "button": "№ кнопки 758",
      "bids": 7,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }, {
      "chid": 3143,
      "title": "Грозный",
      "biglogo": "/chbiglogo/1587707740.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474885201.png",
      "description": "Региональный канал Чеченской Республики для чеченцев, живущих в разных регионах России, и для зрителей, которые интересуются жизнью Чечни. В эфире познавательные, детские, развлекательные, музыкальные, публицистические и посвященные исламу программы.",
      "url": "http://groztrk.net/",
      "hd": 0,
      "thid": 51,
      "display": 3,
      "alias": "groznyy",
      "xvid": 119,
      "button": "№ кнопки 754",
      "bids": 7,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }],
    "channelsCount": 6,
    "channelsCountHd": 0,
    "children": [],
    "color": "linear-gradient(278.34deg, #BD9CD5 29.94%, #AB7FC3 82.17%, #AB7FC3 82.63%)",
    "cost": 200,
    "costRa": [],
    "description": "Информационные и развлекательные каналы Казахстана, Белоруссии, Японии, Кореи, Америки,&nbsp;Украины и Чеченской Республики.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/0c26bab50c914cb3c25b1e3e8f94a67b.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/970a1892130e1bd6414b7f1297196a19.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15732082355601_logo_no_background.png",
    "name": "Национальный",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 99
  }, {
    "id": 103,
    "active": 0,
    "alias": "/domru-tv/packages/dorama",
    "available": 1,
    "baseCost": 200,
    "channels": [{
      "chid": 7173,
      "title": "Дорама HD",
      "biglogo": null,
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1548846308.png",
      "description": "Киноиндустрия Востока: Японии, Южной Кореи, Китая, Тайваня и др. В эфире канала рейтинговые сериалы разных жанров: драмы, мелодрамы, комедии, детективы, исторические сериалы.",
      "url": "http://dorama-tv.com/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "dorama-hd",
      "xvid": 3493,
      "button": "№ кнопки 239",
      "bids": 103,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }],
    "channelsCount": 1,
    "channelsCountHd": 1,
    "children": [],
    "color": "linear-gradient(263.23deg, rgba(228, 75, 130, 0.5) 24.23%, rgba(250, 144, 181, 0.5) 59.31%, rgba(255, 212, 189, 0.5) 101.39%)",
    "cost": 200,
    "costRa": [],
    "description": "Смотри на Восток! Первый канал с сериалами из Южной Кореи, Японии, Китая и Тайваня. Драмы, мелодрамы, комедии, детективы.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/1640846738971_680x280.jpeg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/1640846738971_logo.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/1640846738971_logo_no_background.png",
    "name": "Дорама",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 12
  }, {
    "id": 21,
    "active": 0,
    "alias": "/domru-tv/packages/sport_i_uvlecheniya_hd",
    "available": 1,
    "baseCost": 200,
    "channels": [{
      "chid": 6041,
      "title": "КВН ТВ",
      "biglogo": "/chbiglogo/1587710924.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487048196.png",
      "description": "В эфире игры Высшей и Премьер-лиги КВН, фестивали в Юрмале и Сочи, программы о КВН, репортажи с мероприятий клуба, передачи с участием звезд КВН и российского шоу-бизнеса.",
      "url": "http://kvn.ru/tv",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "kvn-tv",
      "xvid": 2161,
      "button": "№ кнопки 301",
      "bids": 21,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 6311,
      "title": "Сарафан",
      "biglogo": "/chbiglogo/1587712287.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1499413643.png",
      "description": "100 часов юмористических программ и 30 часов скетч-шоу еженедельно. 10 часов нового контента каждую субботу. Классики юмора: Евгений Петросян, Елена Степаненко, Лион Измайлов и другие. В эфире «Кривое зеркало», «Смехопанорама», «Клуб юмора», «Аншлаг».",
      "url": "http://sarafan-tv.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "sarafan",
      "xvid": 1861,
      "button": "№ кнопки 312",
      "bids": 21,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 2793,
      "title": "Телекафе",
      "biglogo": "/chbiglogo/1587715478.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1559294732.png",
      "description": "Кулинарно-развлекательный канал: вкусно, весело, полезно. Готовьте по рецептам российских звёзд вместе с программой «Смак», наблюдайте за жизнью ресторана изнутри в сериале «Кухня», узнайте, как всегда быть в форме без диет с шоу «Минимум калорий».",
      "url": "https://www.telecafe.ru/",
      "hd": 0,
      "thid": 2,
      "display": 3,
      "alias": "telekafe",
      "xvid": 391,
      "button": "№ кнопки 307",
      "bids": 21,
      "theme": {
        "thid": 2,
        "name": "Развлекательные",
        "plural": "Развлекательные",
        "alias": "party",
        "weight": 2
      }
    }, {
      "chid": 7553,
      "title": "365 Дней",
      "biglogo": "/chbiglogo/1587713232.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561112868.png",
      "description": "Учебник истории на вашем экране. В эфире канала программы, документальные циклы и фильмы об истории России и мира. Изучайте и анализируйте исторические события, знакомьтесь с великими людьми прошлого и их судьбами.",
      "url": "https://www.365days.ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "365-dney",
      "xvid": 3473,
      "button": "№ кнопки 416",
      "bids": 21,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 3571,
      "title": "Discovery Science HD",
      "biglogo": "/chbiglogo/1587710774.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1481809290.png",
      "description": "Международный канал о науке и технике, исследованиях и открытиях. История изобретений и технические новинки, строение организма и тайны Вселенной, смелые гипотезы и сенсационные разоблачения.",
      "url": "http://www.discoverychannel.ru/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "discovery-science-hd",
      "xvid": 225,
      "button": "№ кнопки 403",
      "bids": 21,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 2082,
      "title": "English Club HD",
      "biglogo": "/chbiglogo/1587710182.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474874302.png",
      "description": "Канал для тех, кто изучает английский язык. Эфир — это коллекция развлекательных и познавательных сюжетов для погружения в языковую среду. Программы канала развивают навыки чтения, разговорной речи, понимания речи на слух, способствуют преодолению языкового барьера.",
      "url": "http://english-club.tv/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "english-club-hd",
      "xvid": 96,
      "button": "№ кнопки 417",
      "bids": 21,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 5751,
      "title": "Viasat Nature/History HD",
      "biglogo": "/chbiglogo/1587715446.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1556086589.png",
      "description": "Два канала на одной кнопке: с 19:00 до 07:00 (мск) вас ждут разгадки тайн истории, с 07:00 до 19:00 (мск) вы совершите путешествие в мир природы.",
      "url": "http://www.myviasat.ru",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "viasat-naturehistory-hd",
      "xvid": 477,
      "button": "№ кнопки 419",
      "bids": 21,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 5511,
      "title": "Бобер",
      "biglogo": "/chbiglogo/1587710629.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474892503.png",
      "description": "Канал о современном дизайне и решениях, которые помогут создать уют в доме, офисе и на даче. Ведущие канала — дизайнеры интерьеров, архитекторы, строители, ландшафтные специалисты. Они рассказывают и показывают как обустроить пространство своими руками.",
      "url": "http://www.bober-tv.ru/",
      "hd": 0,
      "thid": 7,
      "display": 3,
      "alias": "bober",
      "xvid": 1251,
      "button": "№ кнопки 427",
      "bids": 21,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 6563,
      "title": "Доктор HD",
      "biglogo": "/chbiglogo/1587714490.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1604057226.png",
      "description": "Канал о достижениях медицины, новых методах диагностики и лечения болезней.",
      "url": "http://doc-tv.ru/",
      "hd": 1,
      "thid": 7,
      "display": 3,
      "alias": "doktor-hd",
      "xvid": 2723,
      "button": "№ кнопки 404",
      "bids": 21,
      "theme": {
        "thid": 7,
        "name": "Познавательные",
        "plural": "Познавательные",
        "alias": "brain",
        "weight": 3
      }
    }, {
      "chid": 7573,
      "title": "M-1 Global HD",
      "biglogo": "/chbiglogo/1638772727.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1638772727.png",
      "description": "Телеканал ММА-ТV.соm (новое имя M-1 Global) – уникальный тематический телеканал, посвященный MMA. Контент: прямые трансляции турниров MMA Серии, турниры по MMA международных лиг, новостные и авторские программы, фильмы о бойцах и развитии российского и мирового MMA. \r\nMMA-TV.com – бренд, целевой аудиторией которого являются поклонники MMA. Трансляция круглосуточная, на двух языках (рус, англ).",
      "url": "https://m-1global.com/tv",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "m-1-global-hd",
      "xvid": 3483,
      "button": "№ кнопки 511",
      "bids": 21,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 3701,
      "title": "АВТО24 HD",
      "biglogo": "/chbiglogo/1587712332.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502689416.png",
      "description": "Канал об авто: прямые трансляции российских и мировых чемпионатов, новости автомобильного мира, спецпроекты и интервью.",
      "url": "http://avto24tv.ru/",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "avto24-hd",
      "xvid": 46,
      "button": "№ кнопки 505",
      "bids": 21,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 672,
      "title": "Cartoon Network",
      "biglogo": "/chbiglogo/1587711584.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1490161905.png",
      "description": "Развлекательный канал для детей от 6 до 12 лет.  В эфире комедийные и приключенческие мультсериалы: «Время приключений», «Суперкрошки», «Удивительный мир Гамбола», «Бен 10», «Вся правда о медведях» и другие.",
      "url": "http://www.cartoonnetwork.ru/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "cartoon-network",
      "xvid": 226,
      "button": "№ кнопки 604",
      "bids": 21,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }],
    "channelsCount": 12,
    "channelsCountHd": 6,
    "children": [],
    "color": "linear-gradient(65.85deg, #9D97F7 1.66%, #8C84F3 52.2%, #665FCC 95.97%)",
    "cost": 200,
    "costRa": [{
      "cost": 170,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115866
    }, {
      "cost": 150,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115890
    }],
    "description": "<p>Изучайте английский с каналом English Club HD, узнайте как приготовить сырный скрэмбл вместе «Телекафе», смейтесь с «КВН ТВ».  </p>",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/f5156e1332f9d2a670671145702cda1d.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/92726d955e15b0a213319add00d176df.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15730134405355_logo_no_background.png",
    "name": "Спорт и увлечения HD",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 15
  }, {
    "id": 2,
    "active": 0,
    "alias": "/domru-tv/packages/insomnia",
    "available": 1,
    "baseCost": 230,
    "channels": [{
      "chid": 6383,
      "title": "Brazzers Europe",
      "biglogo": "/chbiglogo/1587714598.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520930958.png",
      "description": "Самый откровенный эротический канал Playboy. В эфире — европейские и американские видео разных направлений.",
      "url": "https://www.brazzers.com/",
      "hd": 0,
      "thid": 53,
      "display": 3,
      "alias": "brazzers-europe",
      "xvid": 2423,
      "button": "№ кнопки 805",
      "bids": 2,
      "theme": {
        "thid": 53,
        "name": "Каналы для взрослых",
        "plural": "Каналы для взрослых",
        "alias": 18,
        "weight": 13
      }
    }, {
      "chid": 4091,
      "title": "О-ля-ля",
      "biglogo": "/chbiglogo/1587710478.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886690.png",
      "description": "Первый российский эротический. Основной контент — фильмы мировых студий VIVID, DreamGirls, ADAM&EVE. Это разные жанры и форматы видео  зарубежных и российских создателей.",
      "url": "http://o-la-la-tv.com/",
      "hd": 0,
      "thid": 53,
      "display": 3,
      "alias": "o-lya-lya",
      "xvid": 249,
      "button": "№ кнопки 803",
      "bids": 2,
      "theme": {
        "thid": 53,
        "name": "Каналы для взрослых",
        "plural": "Каналы для взрослых",
        "alias": 18,
        "weight": 13
      }
    }, {
      "chid": 7583,
      "title": "Русская ночь",
      "biglogo": "/chbiglogo/1587715545.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1561632115.png",
      "description": "Канал с рейтингом 18+. В эфире мировая киноэротика, фильмы и сериалы, телевизионные шоу и клипы эротической направленности.",
      "url": "",
      "hd": 0,
      "thid": 53,
      "display": 3,
      "alias": "russkaya-noch",
      "xvid": 3513,
      "button": "№ кнопки 801",
      "bids": 2,
      "theme": {
        "thid": 53,
        "name": "Каналы для взрослых",
        "plural": "Каналы для взрослых",
        "alias": 18,
        "weight": 13
      }
    }, {
      "chid": 1942,
      "title": "Шелк",
      "biglogo": "/chbiglogo/1617887538.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1617887538.png",
      "description": "Телеканал для взрослых с кинематографическими съёмками специально подобранных моделей. Дарит визуальное удовольствие.",
      "url": "",
      "hd": 0,
      "thid": 53,
      "display": 3,
      "alias": "shelk",
      "xvid": 5061,
      "button": "№ кнопки 802",
      "bids": 2,
      "theme": {
        "thid": 53,
        "name": "Каналы для взрослых",
        "plural": "Каналы для взрослых",
        "alias": 18,
        "weight": 13
      }
    }],
    "channelsCount": 4,
    "channelsCountHd": 0,
    "children": [],
    "color": "linear-gradient(235.23deg, rgba(181, 124, 251, 0.84) -34.06%, rgba(184, 135, 242, 0.741771) 32.04%, rgba(186, 146, 234, 0.64) 91.46%)",
    "cost": 230,
    "costRa": [{
      "cost": 200,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115860
    }, {
      "cost": 180,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115886
    }],
    "description": "Мы никому не расскажем. Каналы 18+ пикантного жанра для тех, кому хочется погорячее.\r\n<br />\r\n<br />*Пакет телеканалов недоступен для Smart TV.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/4e8459c2e52ed1e1303be98de11c8e88.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/66bf9898f049d68dc5671be4cbd67710.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/1573208318607_logo_no_background.png",
    "name": "Бессонница",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 5
  }, {
    "id": 32,
    "active": 0,
    "alias": "/domru-tv/packages/tvrain",
    "available": 1,
    "baseCost": 240,
    "channels": [{
      "chid": 5031,
      "title": "Дождь HD",
      "biglogo": "/chbiglogo/1587710522.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474891866.png",
      "description": "Российский информационный канал. В эфире новостные, аналитические, дискуссионные и авторские программы, концерты, художественные чтения, а также документальные фильмы, видео-арт.",
      "url": "https://tvrain.ru/",
      "hd": 1,
      "thid": 12,
      "display": 3,
      "alias": "dozhd-hd",
      "xvid": 1191,
      "button": "№ кнопки 707",
      "bids": 32,
      "theme": {
        "thid": 12,
        "name": "Новостные",
        "plural": "Новостные",
        "alias": "news",
        "weight": 7
      }
    }],
    "channelsCount": 1,
    "channelsCountHd": 1,
    "children": [],
    "color": " linear-gradient(291deg, #EB6993 -3.98%, rgba(246, 157, 186, 0.91) 95.12%)",
    "cost": 240,
    "costRa": [{
      "cost": 190,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115874
    }, {
      "cost": 140,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115898
    }],
    "description": "<div>Независимый российский инфотейнмент телеканал. Дождь —&nbsp;это не только новости, но еще музыка и фильмы, путешествия и социальные проекты, лекции и круглые столы.</div>",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15870301129343_680x280.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/e03d4faae3adf98a388ec87962105ce7.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15732083623298_logo_no_background.png",
    "name": "Дождь",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 17
  }, {
    "id": 74,
    "active": 0,
    "alias": "/domru-tv/packages/shant-premium-hd",
    "available": 1,
    "baseCost": 240,
    "channels": [{
      "chid": 6211,
      "title": "Шант Premium HD",
      "biglogo": "/chbiglogo/1587711347.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1487051790.png",
      "description": "Канал на армянском языке. В эфире — новостные, познавательные и развлекательные передачи, фильмы и сериалы, а также версии почти всех мировых передач на армянском.",
      "url": "https://www.shanttv.com/ru/home.html",
      "hd": 1,
      "thid": 51,
      "display": 3,
      "alias": "shant-premium-hd",
      "xvid": 2101,
      "button": "№ кнопки 750",
      "bids": 74,
      "theme": {
        "thid": 51,
        "name": "Национальные",
        "plural": "Национальные",
        "alias": "etno",
        "weight": 8
      }
    }],
    "channelsCount": 1,
    "channelsCountHd": 1,
    "children": [],
    "color": "linear-gradient(291.8deg, #D96F4E 0.85%, rgba(221, 129, 100, 0.8) 95.11%)",
    "cost": 240,
    "costRa": [{
      "cost": 190,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1118676
    }, {
      "cost": 140,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1118672
    }],
    "description": "Армянский телеканал. Новостные, познавательные и развлекательные передачи, фильмы и сериалы.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/25b49aede7a8a979cd503f6f17574029.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/b60596cccc4d86289901d44154ca0457.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15732085309165_logo_no_background.png",
    "name": "Шант Premium HD",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 98
  }, {
    "id": 20,
    "active": 0,
    "alias": "/domru-tv/packages/umka",
    "available": 1,
    "baseCost": 299,
    "channels": [{
      "chid": 5531,
      "title": "Ani",
      "biglogo": "/chbiglogo/1587706453.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474892526.png",
      "description": "Для детей 6-12 лет. В эфире мультфильмы из разных стран мира. Среди них уже знакомые нашим детям «Шарлотта‑Земляничка», «Веселые паровозики из Чаддингтона», «Пингвиненок Пороро», «Катя и Мим-Мим», «Леонардо», «Тайо маленький автобус» и другие.",
      "url": "http://ani.tlum.ru/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "ani",
      "xvid": 1241,
      "button": "№ кнопки 603",
      "bids": 20,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 3471,
      "title": "Baby TV",
      "biglogo": "/chbiglogo/1587706541.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474885962.png",
      "description": "Канал для детей до 3-х лет на английском языке. Малыш может петь, играть, рисовать, слушать истории, учиться читать, считать, общаться и познавать.\r\nКанал показывает без рекламы.",
      "url": "http://www.babytv.com/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "baby-tv",
      "xvid": 48,
      "button": "№ кнопки 611",
      "bids": 20,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 3451,
      "title": "Nick Jr.",
      "biglogo": "/chbiglogo/1587706718.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665897.png",
      "description": "Для дошкольного возраста.\r\nВместе с героями шоу «Щенячий патруль», «Вспыш и чудо‑машинки», «Шиммер и Шайн», «Нелла, отважная принцесса» и «Даша‑путешественница» дети в игровой форме учатся основам математики, логики и иностранных языков. У них развивается внимательность и фантазия.",
      "url": "http://www.nickjr.com/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "nick-jr",
      "xvid": 210,
      "button": "№ кнопки 602",
      "bids": 20,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 2383,
      "title": "Nickelodeon HD",
      "biglogo": "/chbiglogo/1587706839.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665903.png",
      "description": "Первый детский канал в HD-качестве, которое делает приключения любимых героев еще ярче. Эфир — это несколько тысяч часов контента: «Даша и друзья: приключения в городе», «Чудище Бансен», «ЭлвиННН!!! И бурундуки», «Опасный Генри», «Грозная семейка» и многое другое.",
      "url": "http://www.nickelodeon.ru/",
      "hd": 1,
      "thid": 11,
      "display": 3,
      "alias": "nickelodeon-hd",
      "xvid": 209,
      "button": "№ кнопки 609",
      "bids": 20,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 9703,
      "title": "МУЛЬТ HD",
      "biglogo": "/chbiglogo/1587707007.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1575273759.png",
      "description": "Телеканал российских мультфильмов для детей до 6 лет. Веселые Кубики расскажут, как устроен космос, Фиксики познакомят ребят с техникой, а общаться и дружить научат Лунтик, Малышарики и Барбоскины.",
      "url": "http://mult.tlum.ru/",
      "hd": 1,
      "thid": 11,
      "display": 3,
      "alias": "mult-hd",
      "xvid": 2693,
      "button": "№ кнопки 616",
      "bids": 20,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 6483,
      "title": "О!  ",
      "biglogo": "/chbiglogo/1587707120.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520930205.png",
      "description": "По статистике четырехлетний малыш в день задает около 450 вопросов. Этот канал дает на них ответы! Здесь собраны  развивающие передачи и мультфильмы, которые учат читать, считать, рисовать и говорить по-английски. По выходным дням на «О!» идут художественные и анимационные фильмы. Можно смотреть всей семьей.",
      "url": "http://www.kanal-o.ru/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "o",
      "xvid": 2603,
      "button": "№ кнопки 610",
      "bids": 20,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 481,
      "title": "Радость моя",
      "biglogo": "/chbiglogo/1587707183.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502688644.png",
      "description": "Семейный образовательный канал. Знакомит детей с законами математики, физики, биологии, химии. Передачи для семейного просмотра – «Домашний очаг», «Неравнодушный разговор». Особенность канала — блок православных программ: история русской церкви, вопросы духовности, православные праздники.",
      "url": "http://www.radostmoya.ru",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "radost-moya",
      "xvid": 265,
      "button": "№ кнопки 613",
      "bids": 20,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 4161,
      "title": "Рыжий",
      "biglogo": "/chbiglogo/1587707200.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474887066.png",
      "description": "Для детей от 5 до 12 лет. Любимые серии популярных мультфильмов «Лунтик», «Фиксики», «Смешарики», «Маша и медведь», «Алиса знает, что делать», «Летающие звери», «Пузыри» круглосуточно! Добрые советские мультфильмы, фильмы и сериалы для детей постарше. Передачи канала сопровождает язык жестов для детей с ограничением слуха.",
      "url": "http://ryzhiy.tv/",
      "hd": 0,
      "thid": 11,
      "display": 3,
      "alias": "ryzhiy",
      "xvid": 502,
      "button": "№ кнопки 614",
      "bids": 20,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }, {
      "chid": 3461,
      "title": "СТС Kids HD",
      "biglogo": "/chbiglogo/1617887899.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1617887899.png",
      "description": "Телеканал для детей, которые любят хорошие мультфильмы и для родителей, которые хотят, чтобы их дети обучались развлекаясь. Программа передач разработана с учетом рекомендаций экспертов психологического факультета МГУ им. М.В. Ломоносова. В эфире СТС Kids идут знаменитые мировые франшизы: «Кот в сапогах», «Король Джулиан», «Семейка Крудс», «Драконы. Гонки по краю», «Мистер Пибоди и Шерман», анимационные проекты собственного производства: «Три кота», «Царевны» и другие.",
      "url": "",
      "hd": 1,
      "thid": 11,
      "display": 3,
      "alias": "sts-kids-hd",
      "xvid": 5051,
      "button": "№ кнопки 612",
      "bids": 20,
      "theme": {
        "thid": 11,
        "name": "Детские",
        "plural": "Детские",
        "alias": "kinder",
        "weight": 5
      }
    }],
    "channelsCount": 9,
    "channelsCountHd": 3,
    "children": [],
    "color": "linear-gradient(210.76deg, #00B1FF -7.91%, rgba(65, 226, 255, 0.95) 92.41%)",
    "cost": 299,
    "costRa": [{
      "cost": 269,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1116143
    }, {
      "cost": 249,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1116145
    }],
    "description": "Канал «O!» расскажет откуда берется радуга, а Nickelodeon HD — о новых приключениях Губки Боба. А ещё ребенок сможет учить английский на канале Baby TV.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/f9f9d79c093c78be6855da4a2cee944e.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/b4900711984edeb1e6387d99853c212f.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15732084619513_logo_no_background.png",
    "name": "Умка",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 16
  }, {
    "id": 3,
    "active": 0,
    "alias": "/domru-tv/packages/nash_football_hd",
    "available": 1,
    "baseCost": 299,
    "channels": [{
      "chid": 168,
      "title": "МАТЧ ПРЕМЬЕР",
      "biglogo": "/chbiglogo/1587708118.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1532594973.png",
      "description": "Единственный телеканал, полностью посвященный российскому футболу. Все матчи, команды, турниры. Тематические, обзорные программы, лучшие тренеры, футболисты и комментаторы страны.",
      "url": "https://matchtv.ru/premier",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "match-premer",
      "xvid": 214,
      "button": "№ кнопки 502",
      "bids": 3,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }],
    "channelsCount": 1,
    "channelsCountHd": 1,
    "children": [],
    "color": "linear-gradient(287.17deg, #423E3B 10.18%, #2A2422 97.76%)",
    "cost": 299,
    "costRa": [{
      "cost": 269,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115872
    }, {
      "cost": 249,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1115896
    }],
    "description": "Новый телеканал о российском футболе. Смотрите все матчи Российской Премьер-лиги в прямом эфире.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/4e2401606ed7a729c31840d3a4507d59.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/6180bb11fbeaa1fee6baac979f8b7c26.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15730137987493_logo_no_background.png",
    "name": "Матч! Премьер",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 5
  }, {
    "id": 75,
    "active": 0,
    "alias": "/domru-tv/bundles/viasat_premium_hd",
    "available": 1,
    "baseCost": 299,
    "channels": [{
      "chid": 3431,
      "title": "ViP Comedy",
      "biglogo": "/chbiglogo/1587714696.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665546.png",
      "description": "Киноканал, целиком посвященный комедии. Все грани смешного: лирика и юмор, сатира и абсурд, уморительные гэги и задорные приключения.",
      "url": "http://www.viasat.ru",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "vip-comedy",
      "xvid": 435,
      "button": "№ кнопки 225",
      "bids": 75,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 3421,
      "title": "ViP Megahit",
      "biglogo": "/chbiglogo/1587714714.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665554.png",
      "description": "Настоящие кинохиты, мировые блокбастеры, любимые кинофраншизы и культовые ленты. Кино, которое вам захочется пересматривать снова и снова!",
      "url": "https://www.viasat.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "vip-megahit",
      "xvid": 436,
      "button": "№ кнопки 204",
      "bids": 75,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 3441,
      "title": "ViP Premiere",
      "biglogo": "/chbiglogo/1587714748.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665560.png",
      "description": "Кино прямо с экранов кинотеатров, эксклюзивные телепремьеры от крупнейших киностудий мира. Вы увидите это первыми!",
      "url": "https://www.viasat.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "vip-premiere",
      "xvid": 437,
      "button": "№ кнопки 224",
      "bids": 75,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 3711,
      "title": "ViP Serial ",
      "biglogo": "/chbiglogo/1587714782.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1553665567.png",
      "description": "Телеканал мировых сериалов. Интриги, яркие исторические события, детективы, триллеры и фантастика – каждый найдёт себе сериал по вкусу.",
      "url": "https://www.viasat.ru/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "vip-serial",
      "xvid": 3293,
      "button": "№ кнопки 249",
      "bids": 75,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 3591,
      "title": "Viasat Sport HD",
      "biglogo": "/chbiglogo/1587710310.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886206.png",
      "description": "Приготовьтесь к мощной порции адреналина! Только на канале Viasat Sport HD в прямом эфире и с профессиональным комментарием вы увидите игры Национальной Футбольной Лиги NFL, бейсбольные матчи MLB, хоккейные матчи SHL и AHL, автогонки Indycar, Польскую футбольную лигу Ekstraklasa, баскетбол и американский футбол NCAA, боксёрские поединки, экстремальные игры X-Games и многое другое.",
      "url": "https://www.viasat.ru/",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "viasat-sport-hd",
      "xvid": 479,
      "button": "№ кнопки 513",
      "bids": 75,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }],
    "channelsCount": 5,
    "channelsCountHd": 5,
    "children": [],
    "color": "linear-gradient(40.05deg, #29212E -14.32%, #3E2E48 32.79%, #584064 84.04%)",
    "cost": 299,
    "costRa": [],
    "description": "Премьеры голливудских и российских фильмов, новые сериалы, мегахиты, природа, история и спорт.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/5141fd0ab854f5b47b8d44397303851f.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/754fa6c997d4a6721f80dc9002d7b247.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15730145328089_logo_no_background.png",
    "name": "ViP",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 5
  }, {
    "id": 31,
    "active": 0,
    "alias": "/domru-tv/packages/ntv-plus-football",
    "available": 1,
    "baseCost": 400,
    "channels": [{
      "chid": 872,
      "title": "МАТЧ! ФУТБОЛ 1 HD",
      "biglogo": "/chbiglogo/1587705738.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474873432.png",
      "description": "Телеканал, посвященный мировому футболу. Смотрите трансляции игр Лиги чемпионов и Лиги Европы, а также матчей испанской Ла Лиги.",
      "url": "https://matchtv.ru/match_football_channels",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "match-futbol-1-hd",
      "xvid": 216,
      "button": "№ кнопки 510",
      "bids": 31,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 4141,
      "title": "МАТЧ! ФУТБОЛ 2 HD",
      "biglogo": "/chbiglogo/1599458047.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886994.png",
      "description": "Трансляции игр Чемпионата Франции, Лиги чемпионов и Лиги Европы. Чемпионаты Мира и Европы. Канал специализируется на освещении Ла Лиги — чемпионата Испании.",
      "url": "https://matchtv.ru/match_football_channels",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "match-futbol-2-hd",
      "xvid": 235,
      "button": "№ кнопки 518",
      "bids": 31,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 5691,
      "title": "МАТЧ! ФУТБОЛ 3 HD",
      "biglogo": "/chbiglogo/1599458195.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474892808.png",
      "description": "Трансляции игр Лиги чемпионов и Лиги Европы. Чемпионаты Италии, Германии, Франции. В эфире канала — один из самых зрелищных национальных первенств — Бундеслиги, чемпионата Германии.",
      "url": "https://matchtv.ru/match_football_channels",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "match-futbol-3-hd",
      "xvid": 1351,
      "button": "№ кнопки 519",
      "bids": 31,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }],
    "channelsCount": 3,
    "channelsCountHd": 3,
    "children": [],
    "color": "linear-gradient(64.69deg, #94D880 1.63%, #7AC170 94.51%)",
    "cost": 400,
    "costRa": [{
      "cost": 350,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1116198
    }, {
      "cost": 300,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1116202
    }],
    "description": "Пакет для тех, кто живет футболом: матчи зрелищных чемпионатов в прямом эфире, выпуски новостей, обзоры и превью.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/c056e6311cf361c485936e0350754be4.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/540d21434fbb0ba2b95f5843a667095b.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15730138843062_logo_no_background.png",
    "name": "Матч! Футбол",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 9
  }, {
    "id": 1,
    "active": 0,
    "alias": "/domru-tv/packages/ntv_plus_kino",
    "available": 1,
    "baseCost": 400,
    "channels": [{
      "chid": 832,
      "title": "КИНОПРЕМЬЕРА HD",
      "biglogo": "/chbiglogo/1587709701.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502689369.png",
      "description": "Новинки российского и зарубежного кино за последние два года. То, что вы не успели посмотреть в кинотеатре — теперь у вас дома.",
      "url": "http://www.nastroykino.ru/kinopremyera/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "kinopremera-hd",
      "xvid": 215,
      "button": "№ кнопки 226",
      "bids": 1,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6643,
      "title": "КИНОСВИДАНИЕ HD",
      "biglogo": "/chbiglogo/1587709778.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520919139.png",
      "description": "Кино для просмотра вдвоем. Романтические комедии, фильмы об историях любви и психологии отношений.",
      "url": "http://www.nastroykino.ru/kinosvidanie/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "kinosvidanie-hd",
      "xvid": 231,
      "button": "№ кнопки 227",
      "bids": 1,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6633,
      "title": "КИНОСЕМЬЯ HD",
      "biglogo": "/chbiglogo/1587709869.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520919164.png",
      "description": "Детское кино и полнометражные мультфильмы, фильмы о дружбе и семейных ценностях. Канал показывает фильмы с повтором в разное время — выберите, когда вам удобно смотреть.",
      "url": "http://www.nastroykino.ru/kinosemja/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "kinosemya-hd",
      "xvid": 124,
      "button": "№ кнопки 218",
      "bids": 1,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 6653,
      "title": "КИНОХИТ HD",
      "biglogo": "/chbiglogo/1587709905.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1520919279.png",
      "description": "Фильмы, которые завоевали мировую славу. Зарубежные триллеры, боевики, мелодрамы и комедии с самыми высокими рейтингами среди зрителей.",
      "url": "http://www.nastroykino.ru/kinohit/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "kinokhit-hd",
      "xvid": 232,
      "button": "№ кнопки 231",
      "bids": 1,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }, {
      "chid": 5211,
      "title": "МУЖСКОЕ КИНО HD",
      "biglogo": "/chbiglogo/1587709924.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1502689240.png",
      "description": "Зарубежные и российские детективы, боевики, криминальные драмы и хорроры. Смесь драйва, скорости, адреналина, перестрелок, крутых автомобилей и красивых женщин.",
      "url": "http://www.nastroykino.ru/muzhskoe-kino/",
      "hd": 1,
      "thid": 6,
      "display": 3,
      "alias": "muzhskoe-kino-hd",
      "xvid": 1531,
      "button": "№ кнопки 235",
      "bids": 1,
      "theme": {
        "thid": 6,
        "name": "Фильмовые",
        "plural": "Фильмовые",
        "alias": "film",
        "weight": 1
      }
    }],
    "channelsCount": 5,
    "channelsCountHd": 5,
    "children": [],
    "color": "linear-gradient(238.8deg, #8968C3 22.95%, #A383D2 46.96%, #C6ADE9 107.68%)",
    "cost": 400,
    "costRa": [{
      "cost": 350,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1125875
    }, {
      "cost": 300,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1125877
    }],
    "description": "Пять каналов для киноманов. У каждого свое направление: премьеры, хиты, фильмы о любви, мужское кино и мультфильмы.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/0f24cddada0df94e02393560a221e254.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/903d435ed7cf65d7473aba1753a32f5f.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15730137304439_logo_no_background.png",
    "name": "Настрой кино",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 4
  }, {
    "id": 5,
    "active": 0,
    "alias": "/domru-tv/packages/ntv_plus_sport",
    "available": 1,
    "baseCost": 400,
    "channels": [{
      "chid": 4121,
      "title": "МАТЧ! АРЕНА HD",
      "biglogo": "/chbiglogo/1587708448.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886984.png",
      "description": "Самые престижные мировые турниры в прямом эфире: Олимпийские Игры, Чемпионаты мира и Европы по легкой атлетике, биатлону, лыжным гонкам, фигурному катанию, водным видам спорта и другие.",
      "url": "https://matchtv.ru/matchtv_thematic_channels",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "match-arena-hd",
      "xvid": 1581,
      "button": "№ кнопки 506",
      "bids": 5,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 5241,
      "title": "МАТЧ! БОЕЦ",
      "biglogo": "/chbiglogo/1587708545.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474892139.png",
      "description": "В эфире канала — профессиональные и любительские единоборства: бокс, смешанные единоборства, кикбоксинг, дзюдо, борьба, самбо и другие. Прямые трансляции зрелищных боев мира с участием российских и зарубежных спортсменов.",
      "url": " http://www.boets.ru/",
      "hd": 0,
      "thid": 10,
      "display": 3,
      "alias": "match-boets",
      "xvid": 51,
      "button": "№ кнопки 503",
      "bids": 5,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }, {
      "chid": 4001,
      "title": "МАТЧ! ИГРА HD",
      "biglogo": "/chbiglogo/1587708607.png",
      "logo": "https://master.epg-front.web.t2.ertelecom.ru/chlogo/1474886639.png",
      "description": "Рейтинговые мировые турниры в прямом эфире: Европейские клубные турниры  по баскетболу, волейболу, гандболу, теннису и другим игровым групповым видам спорта.",
      "url": "https://perm.domru.ru/domru-tv/channel/4001",
      "hd": 1,
      "thid": 10,
      "display": 3,
      "alias": "match-igra-hd",
      "xvid": 1591,
      "button": "№ кнопки 509",
      "bids": 5,
      "theme": {
        "thid": 10,
        "name": "Спортивные",
        "plural": "Спортивные",
        "alias": "sport",
        "weight": 4
      }
    }],
    "channelsCount": 3,
    "channelsCountHd": 2,
    "children": [],
    "color": "linear-gradient(96.77deg, #F9BC4B -47.18%, #FAAC4B 6.09%, rgba(249, 168, 76, 0.95) 31.17%, rgba(247, 159, 69, 0.95) 54.69%, rgba(247, 154, 66, 0.972563) 75.9%, #F7913B 94.04%)",
    "cost": 400,
    "costRa": [{
      "cost": 350,
      "duration": 3,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1116196
    }, {
      "cost": 300,
      "duration": 6,
      "durationTypeId": 1,
      "groups": [390],
      "raId": 1116200
    }],
    "description": "Прямые трансляции, тематические и информационные передачи, посвященные самым различным видам спорта.",
    "image": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/cf53a4b497163e499d220f5eabdb8559.jpg",
    "label": "",
    "logo": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/4ce0f7f924d5bca7074186485a53e6d1.png",
    "logoNoBackground": "https://master.epg-front.web.t2.ertelecom.ru/images/ctvPacket/15730139220496_logo_no_background.png",
    "name": "Матч! Спорт",
    "nextRa": [],
    "packetType": 2,
    "state": {
      "actDateTo": null,
      "dateFrom": null,
      "dateTo": null,
      "dateOff": null,
      "duration": null,
      "platform": "",
      "prolong": 0,
      "unsetState": 0,
      "unsetFrom": null
    },
    "weight": 10
  }],
  "channelsCountInTariff": {
    "total": 194,
    "sd": 124,
    "hd": 70
  },
  "terminalId": 3131282
};